import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";

import state from "../state";
import ColorSetter from "./NewColorPicker";
import ImageUploader from "./ImageUploader";
import GKEvent from "../events";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Switch from "@material-ui/core/Switch";
import SlideDialog from "./SlideDialog";
import ListDialog from "./ListDialog";

import Icon from "./Icons";

import { Select, TextField } from "./FormElements";
import SliderRange from "./SliderRange";

import { inArray, l, isObject } from "../functions";
import { ajaxUri } from "../consts/index";
import { fontList as globalFontList } from "../consts/fonts";
import iconList from "../consts/iconsList";

import isEqual from "lodash/isEqual";
import NewColorPicker from "./NewColorPicker";
import HoverSpacer from "./HoverSpacer";

const mapStateToProps = (state) => {
  return {
    elementToEdit: state.rootReducer.elementToEdit || null,
    fetchedPages: state.rootReducer.fetchedPages || [],
    fetchedProducts: state.rootReducer.fetchedProducts || [],
    fetchedCategories: state.rootReducer.fetchedCategories || [],
    elementOptions: state.rootReducer.elementOptions || [],
    currentDevice: state.rootReducer.currentDevice || "xl",
    fetchedLangs: state.rootReducer.fetchedLangs || [],
    currentLang: state.rootReducer.currentLang || 1,
    showBlockSettings: state.rootReducer.showBlockSettings || false,
    settings: state.rootReducer.appearanceSettings || {},
    alwaysOpenStyle: state.rootReducer.alwaysOpenStyle ?? false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editElement: (element) => dispatch({ type: "EDIT_ELEMENT", element }),
    setShowBlockSettings: () =>
      dispatch({ type: "SHOW_BLOCK_SETTINGS", showBlockSettings: false }),
    setAlwasOpen: (open) => dispatch({ type: "SET_ALWAYS_OPEN", open }),
  };
};

class BlockSettings extends Component {
  constructor(props) {
    super(props);

    this.defaultSettings = {
      background: {
        backgroundImage: null,
        backgroundColor: null,
        backgroundSize: "cover",
        backgroundRepeat: "repeat",
        backgroundPosition: "center center",
      },
      border: {
        borderLeft: null,
        borderTop: null,
        borderRight: null,
        borderBottom: null,
      },
      spacing: null,
      text: null,
      alignment: null,
    };

    this.defaultState = {
      currentDrop: 0,
      current_style: null,
      currentTab: 1,
      slideDialog: null,
      selectedFields: {},
      selectedFieldsValue: {},
      globalSettings: {},
      url: "",
      advanceSettings: false,
      showAppearance: false,
      hideAdvanceSettings: false,
      showAppearanceMessage: true,
    };

    this.state = {
      ...this.defaultState,
      ...{
        listDatas: null,
        styles: [],
        datas: {},
        settings: this.defaultSettings,
      },
    };

    this.fontList = globalFontList;

    this.weightLabel = {
      200: "Extra light",
      300: "Light",
      400: "Regular",
      500: "Medium",
      600: "Semi bold",
      700: "Bold",
      800: "Extra bold",
      900: "Black",
    };

    this.animations = [
      {
        label: "Bounce",
        value: "bounce animated",
      },
      {
        label: "Flash",
        value: "flash animated",
      },
      {
        label: "Pulse",
        value: "pulse animated",
      },
      {
        label: "Rubber Band",
        value: "rubberBand animated",
      },
      {
        label: "Shake",
        value: "shake animated",
      },
      {
        label: "Swing",
        value: "swing animated",
      },
      {
        label: "Tada",
        value: "tada animated",
      },
      {
        label: "Wobble",
        value: "wobble animated",
      },
      {
        label: "Jello",
        value: "jello animated",
      },
      {
        label: "Heart Beat",
        value: "heartBeat animated",
      },
      {
        label: "Bounce In",
        value: "bounceIn animated",
      },
      {
        label: "Bounce Out",
        value: "bounceOut animated",
      },
      {
        label: "Fade In",
        value: "fadeIn animated",
      },
      {
        label: "Fade Out",
        value: "fadeOut animated",
      },
      {
        label: "Zoom In",
        value: "zoomIn animated",
      },
      {
        label: "Zoom Out",
        value: "zoomOut animated",
      },
      {
        label: "Jack In The Box",
        value: "jackInTheBox animated",
      },
    ];

    this.deviceLabel = {
      xs: l("Mobiles"),
      sm: l("Small tabs"),
      md: l("Large tabs"),
      lg: l("Small screens"),
      xl: l("Large screens"),
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (prevState.settings !== this.state.settings &&
        this.state.settings !== null) ||
      (prevState.datas !== this.state.datas && this.state.datas !== null)
    ) {
      const { elementToEdit } = this.props;
      if (elementToEdit !== null) {
        const { id, dropzoneID, parentID } = elementToEdit;
        const { payload } = state.getFullElement(id, dropzoneID, parentID);

        let settingsIndex = "settings";

        if (this.props.currentDevice !== "xl")
          settingsIndex = settingsIndex + "-" + this.props.currentDevice;

        const newPlayload = {
          ...payload,
          [settingsIndex]: this.state.settings,
          datas: this.state.datas,
        };

        state.updateElement(id, dropzoneID, parentID, {
          payload: newPlayload,
        });
      }
    }
  }

  componentWillReceiveProps({
    elementToEdit,
    currentDevice,
    showBlockSettings,
  }) {
    if (elementToEdit === null) {
      this.setState(this.defaultState);
    } else {
      const oldElement = this.props.elementToEdit;

      if (elementToEdit.type == "row") {
        this.setState({
          hideAdvanceSettings: true,
          advanceSettings: true,
          showAppearanceMessage: false,
        });
      } else {
        this.setState({
          hideAdvanceSettings: false,
          advanceSettings: false,
          showAppearanceMessage: true,
        });
      }
      this.setState({ showAppearance: false });

      if (["image"].includes(elementToEdit.type)) {
        this.setState({ showAppearanceMessage: false });
      } else {
        this.setState({ showAppearanceMessage: true });
      }

      if (
        (oldElement === null ||
          elementToEdit.id !== oldElement.id ||
          this.props.currentDevice !== currentDevice ||
          showBlockSettings) &&
        isObject(elementToEdit)
      ) {
        let datasIndex = "datas";
        let settingsIndex = "settings";

        const { id, dropzoneID, parentID } = elementToEdit;
        const { payload } =
          state.getFullElement(id, dropzoneID, parentID) || {};

        if (currentDevice !== "xl") {
          datasIndex = datasIndex + "-" + currentDevice;
          settingsIndex = settingsIndex + "-" + currentDevice;
        }

        let currentSettings =
          elementToEdit?.payload[settingsIndex] ||
          elementToEdit?.payload?.settings ||
          {};
        if (payload)
          currentSettings = payload[settingsIndex] || payload.settings;

        let currentDatas = elementToEdit.payload.datas || {};
        if (payload) currentDatas = payload?.datas || {};

        const oldDatas = this.props.datas;

        this.setState({
          settings: currentSettings || this.defaultSettings,
          datas: currentDatas !== oldDatas ? currentDatas : [],
          url:
            currentDatas["url_" + this.props.currentLang] ||
            currentDatas.url ||
            "",
          showAppearance: false,
        });

        let availableSettings;

        if (
          this.props.elementOptions[elementToEdit.type] &&
          this.props.elementOptions[elementToEdit.type].settings
        )
          availableSettings =
            this.props.elementOptions[elementToEdit.type].settings;
        // if (Object.keys(availableSettings || {}).length > 7) {
        //   this.setState({ currentTab: 2 });
        // } else {
        //   this.setState({ currentTab: 1 });
        // }

        if (availableSettings && availableSettings.globalSettings) {
          for (const setting of availableSettings.globalSettings)
            this._getGlobalSetting(setting);
        }
      }
    }
  }

  _getGlobalSetting = (key) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getSetting",
        key: key,
      },
    })
      .then((result) => {
        this.setState({
          ...this.state,
          globalSettings: {
            ...this.state.globalSettings,
            [key]: result.data,
          },
        });
      })
      .catch((error) => {
        GKEvent.notification("error", l("Error."));
      });
  };

  _setGlobalSetting = (message, cb = () => { }) => {
    var success = 0;

    for (const key in this.state.globalSettings) {
      if (Object.hasOwnProperty.call(this.state.globalSettings, key)) {
        const value = this.state.globalSettings[key];

        axios({
          method: "post",
          url: ajaxUri,
          data: {
            request: "setSetting",
            key: key,
            value: value,
          },
        })
          .then((result) => {
            success = success + 1;

            if (success == Object.keys(this.state.globalSettings).length) {
              if (message) GKEvent.notification("success", message);

              cb();
            }
          })
          .catch((error) => {
            GKEvent.notification("error", l("Error."));
          });
      }
    }
  };

  _changedGlobalSettings = (key, value, cb = () => { }) => {
    this.setState(
      {
        ...this.state,
        globalSettings: {
          ...this.state.globalSettings,
          [key]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _dropDown = (current) => {
    if (this.state.currentDrop === current) this.setState({ currentDrop: 0 });
    else this.setState({ currentDrop: current });
  };

  _changedDatasOne = (index, value = 0, cb = () => { }) => {
    this.setState(
      {
        ...this.state,
        datas: {
          ...this.state.datas,
          [index]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _changedDatasTwo = (indexOne, indexTwo, value = 0, cb = () => { }) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = { ...this.state.datas[indexOne], ...newvalue };
    } else {
      objectValue = {
        ...this.state.datas[indexOne],
        [indexTwo]: value,
      };
    }

    this._changedDatasOne(indexOne, objectValue, () => {
      cb();
    });
  };

  _changedSettingsOne = (index, value, cb = () => { }) => {
    this.setState(
      {
        ...this.state,
        settings: {
          ...this.state.settings,
          [index]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _changedSettingsTwo = (indexOne, indexTwo, value = 0, cb = () => { }) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = { ...this.state.settings[indexOne], ...newvalue };
    } else {
      objectValue = {
        ...this.state.settings[indexOne],
        [indexTwo]: value,
      };
    }

    this._changedSettingsOne(indexOne, objectValue, () => {
      cb();
    });
  };

  /* Slides Settings - Start */
  _editSlide = (itemId) => {
    this.state.datas.slider.forEach((slide) => {
      if (itemId.toString() === slide.id) this.setState({ slideDialog: slide });
    });
  };

  _removeItem = (itemId, type) => {
    const newItems = [];
    this.state.datas[type].forEach((element) => {
      if (itemId.toString() !== element.id) newItems.push(element);
    });

    this._changedDatasOne(type, newItems);
  };

  _changedSliderSettings = (index, value, cb = () => { }) => {
    this._changedDatasTwo("sliderSettings", index, value, () => {
      cb();
    });
  };

  _changedSliderStyle = (index, value, cb = () => { }) => {
    this._changedSettingsTwo("sliderSettings", index, value, () => {
      cb();
    });
  };

  _changedSliderStyleTwo = (indexOne, indexTwo, value) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = {
        ...(this.state.datas.sliderSettings &&
          this.state.datas.sliderSettings[indexOne]),
        ...(this.state.settings.sliderSettings &&
          this.state.settings.sliderSettings[indexOne]),
        ...newvalue,
      };
    } else {
      objectValue = {
        ...(this.state.datas.sliderSettings &&
          this.state.datas.sliderSettings[indexOne]),
        ...(this.state.settings.sliderSettings &&
          this.state.settings.sliderSettings[indexOne]),
        [indexTwo]: value,
      };
    }
    this._changedSettingsTwo("sliderSettings", indexOne, objectValue, () => { });
  };

  _changedSliderSettingsTwo = (indexOne, indexTwo, value) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = {
        ...this.state.datas.sliderSettings[indexOne],
        ...newvalue,
      };
    } else {
      objectValue = {
        ...this.state.datas.sliderSettings[indexOne],
        [indexTwo]: value,
      };
    }

    this._changedSliderSettings(indexOne, objectValue);
  };
  /* Slides Settings - End */

  _saveItem = (datas, type, cb = () => { }) => {
    const newItems = [];
    this.state.datas[type].forEach((slide) => {
      if (datas.id.toString() !== slide.id) newItems.push(slide);
      else newItems.push(datas);
    });
    this._changedDatasOne(type, newItems, () => {
      cb();
    });
  };

  // settings spacing marginTop
  _setSelectedField = (type, target, field, defaultValue = 0) => {
    const fields =
      (this.state.selectedFields && this.state.selectedFields[target]) || [];
    let finalFields = [];

    if (inArray(field, fields)) {
      fields.forEach((ifield) => {
        if (ifield !== field) finalFields.push(ifield);
      });
    } else {
      fields.push(field);
      finalFields = fields;
    }

    let finalFieldsValue = 0;
    if (finalFields.length > 0) {
      finalFieldsValue =
        (this.state[type] &&
          this.state[type][target] &&
          this.state[type][target][finalFields[0]]) ||
        defaultValue ||
        0;

      finalFields.forEach((jfield) => {
        if (
          this.state[type] &&
          this.state[type][target] &&
          finalFieldsValue !== this.state[type][target][jfield]
        )
          finalFieldsValue = 0;
      });
    }

    this.setState({
      ...this.state,
      selectedFields: {
        ...this.state.selectedFields,
        [target]: finalFields,
      },
      selectedFieldsValue: {
        ...this.state.selectedFieldsValue,
        [target]: finalFieldsValue,
      },
    });
  };

  _fontsFamilyOptions = () => {
    let object = [];

    this.fontList.forEach((font, index) => {
      object.push({
        label: font.name.split("+").join(" "),
        value: index.toString(),
        props: {
          style: { fontFamily: font.cssName },
        },
      });
    });

    return object;
  };

  _fontsWeightOptions = (fontId, fontFamily) => {
    let object = [
      {
        label: "Extra Thin",
        value: 100,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 100 },
        },
      },
      {
        label: "Thin",
        value: 200,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 200 },
        },
      },
      {
        label: "regular",
        value: 300,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 300 },
        },
      },
      {
        label: "Medium",
        value: 400,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 400 },
        },
      },
      {
        label: "Semi Bold",
        value: 500,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 500 },
        },
      },
      {
        label: "Bold",
        value: 600,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 600 },
        },
      },
    ];
    return object;
  };

  _sliderTextOptions = (sliderSettings, item) => {
    return (
      <div>
        <div className="section">
          <Select
            value={
              (sliderSettings && sliderSettings[item + "FontFamilyId"]) || ""
            }
            onChange={(value) => {
              this._changedSliderStyle(item + "FontFamilyId", value, () => {
                this._changedSliderStyle(
                  item + "FontFamily",
                  this.fontList[value].cssName
                );
              });
            }}
            placeholder={l("Google font")}
            options={this._fontsFamilyOptions()}
            dark
          />
        </div>

        <div className="section">
          <label className="small">{l("Size")}</label>
          <SliderRange
            value={(sliderSettings && sliderSettings[item + "FontSize"]) || 16}
            min={10}
            max={100}
            onChange={(value) => {
              this._changedSliderStyle(item + "FontSize", value);
            }}
          />
        </div>

        <div className="section">
          <div className="gk-form-row-container">
            <Select
              value={
                (sliderSettings && sliderSettings[item + "FontWeight"]) || ""
              }
              onChange={(value) => {
                this._changedSliderStyle(item + "FontWeight", value);
              }}
              placeholder={l("Font weight")}
              options={this._fontsWeightOptions(
                (sliderSettings && sliderSettings[item + "FontFamilyId"]) || "",
                (sliderSettings && sliderSettings[item + "FontFamily"]) || ""
              )}
              dark
            />
            <ColorSetter
              color={
                (sliderSettings && sliderSettings[item + "Color"]) || "#000000"
              }
              onChangeComplete={(color) => {
                this._changedSliderStyle(item + "Color", color);
              }}
              right
            />
          </div>
        </div>

        <div className="section">
          <ul className="inline-options dark grow">
            <li
              className={
                sliderSettings && sliderSettings[item + "TextAlign"] === "left"
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this._changedSliderStyle(item + "TextAlign", "left");
              }}
            >
              <FontAwesomeIcon icon={["fa", "align-left"]} />
            </li>
            <li
              className={
                sliderSettings &&
                  sliderSettings[item + "TextAlign"] === "center"
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this._changedSliderStyle(item + "TextAlign", "center");
              }}
            >
              <FontAwesomeIcon icon={["fa", "align-center"]} />
            </li>
            <li
              className={
                sliderSettings && sliderSettings[item + "TextAlign"] === "right"
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this._changedSliderStyle(item + "TextAlign", "right");
              }}
            >
              <FontAwesomeIcon icon={["fa", "align-right"]} />
            </li>
            <li
              className={
                sliderSettings &&
                  sliderSettings[item + "TextAlign"] === "justify"
                  ? "selected"
                  : ""
              }
              onClick={() => {
                this._changedSliderStyle(item + "TextAlign", "justfy");
              }}
            >
              <FontAwesomeIcon icon={["fa", "align-justify"]} />
            </li>
          </ul>
        </div>

        <div className="section">
          <Select
            value={sliderSettings && sliderSettings[item + "LetterSpacing"]}
            onChange={(value) => {
              this._changedSliderStyle(item + "LetterSpacing", value);
            }}
            placeholder={l("Letter spacing")}
            options={[
              {
                label: l("Tight"),
                value: -1,
              },
              {
                label: l("Normal"),
                value: "0",
              },
              {
                label: l("Wide"),
                value: 1,
              },
            ]}
            dark
          />
        </div>

        <div className="section">
          <div className="spacing-area">
            <div className="top">
              <div>
                <input
                  type="text"
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      "datas",
                      "sliderSettings",
                      item + "_marginTop",
                      (sliderSettings && sliderSettings[item + "_marginTop"]) ||
                      0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                      inArray(
                        item + "_marginTop",
                        this.state.selectedFields.sliderSettings
                      )
                      ? "active"
                      : ""
                  }
                  value={
                    (sliderSettings && sliderSettings[item + "_marginTop"]) || 0
                  }
                />
              </div>
            </div>
            <div className="middle">
              <div>
                <input
                  type="text"
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      "datas",
                      "sliderSettings",
                      item + "_marginLeft",
                      (sliderSettings &&
                        sliderSettings[item + "_marginLeft"]) ||
                      0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                      inArray(
                        item + "_marginLeft",
                        this.state.selectedFields.sliderSettings
                      )
                      ? "active"
                      : ""
                  }
                  value={
                    (sliderSettings && sliderSettings[item + "_marginLeft"]) ||
                    0
                  }
                />
              </div>
              <div>
                <div>
                  <span className="padding">{l("Padding")}</span>
                  <input
                    type="text"
                    readOnly
                    onClick={() => {
                      this._setSelectedField(
                        "datas",
                        "sliderSettings",
                        item + "_paddingLeft",
                        (sliderSettings &&
                          sliderSettings[item + "_paddingLeft"]) ||
                        0
                      );
                    }}
                    className={
                      this.state.selectedFields.sliderSettings &&
                        inArray(
                          item + "_paddingLeft",
                          this.state.selectedFields.sliderSettings
                        )
                        ? "active"
                        : ""
                    }
                    value={
                      (sliderSettings &&
                        sliderSettings[item + "_paddingLeft"]) ||
                      0
                    }
                  />
                </div>
                <div>
                  <div>
                    <input
                      type="text"
                      readOnly
                      onClick={() => {
                        this._setSelectedField(
                          "datas",
                          "sliderSettings",
                          item + "_paddingTop",
                          (sliderSettings &&
                            sliderSettings[item + "_paddingTop"]) ||
                          0
                        );
                      }}
                      className={
                        this.state.selectedFields.sliderSettings &&
                          inArray(
                            item + "_paddingTop",
                            this.state.selectedFields.sliderSettings
                          )
                          ? "active"
                          : ""
                      }
                      value={
                        (sliderSettings &&
                          sliderSettings[item + "_paddingTop"]) ||
                        0
                      }
                    />
                  </div>
                  <div></div>
                  <div>
                    <input
                      type="text"
                      readOnly
                      onClick={() => {
                        this._setSelectedField(
                          "datas",
                          "sliderSettings",
                          item + "_paddingBottom",
                          (sliderSettings &&
                            sliderSettings[item + "_paddingBottom"]) ||
                          0
                        );
                      }}
                      className={
                        this.state.selectedFields.sliderSettings &&
                          inArray(
                            item + "_paddingBottom",
                            this.state.selectedFields.sliderSettings
                          )
                          ? "active"
                          : ""
                      }
                      value={
                        (sliderSettings &&
                          sliderSettings[item + "_paddingBottom"]) ||
                        0
                      }
                    />
                  </div>
                </div>
                <div>
                  <input
                    type="text"
                    readOnly
                    onClick={() => {
                      this._setSelectedField(
                        "datas",
                        "sliderSettings",
                        item + "_paddingRight",
                        (sliderSettings &&
                          sliderSettings[item + "_paddingRight"]) ||
                        0
                      );
                    }}
                    className={
                      this.state.selectedFields.sliderSettings &&
                        inArray(
                          item + "_paddingRight",
                          this.state.selectedFields.sliderSettings
                        )
                        ? "active"
                        : ""
                    }
                    value={
                      (sliderSettings &&
                        sliderSettings[item + "_paddingRight"]) ||
                      0
                    }
                  />
                </div>
              </div>
              <div>
                <input
                  type="text"
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      "datas",
                      "sliderSettings",
                      item + "_marginRight",
                      (sliderSettings &&
                        sliderSettings[item + "_marginRight"]) ||
                      0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                      inArray(
                        item + "_marginRight",
                        this.state.selectedFields.sliderSettings
                      )
                      ? "active"
                      : ""
                  }
                  value={
                    (sliderSettings && sliderSettings[item + "_marginRight"]) ||
                    0
                  }
                />
              </div>
            </div>
            <div className="bottom">
              <div>
                <span className="margin">{l("Margin")}</span>
                <input
                  type="text"
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      "datas",
                      "sliderSettings",
                      item + "_marginBottom",
                      (sliderSettings &&
                        sliderSettings[item + "_marginBottom"]) ||
                      0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                      inArray(
                        item + "_marginBottom",
                        this.state.selectedFields.sliderSettings
                      )
                      ? "active"
                      : ""
                  }
                  value={
                    (sliderSettings &&
                      sliderSettings[item + "_marginBottom"]) ||
                    0
                  }
                />
              </div>
            </div>
            <div className="gk-ray a"></div>
            <div className="gk-ray b"></div>
          </div>

          {this.state.selectedFields.sliderSettings &&
            this.state.selectedFields.sliderSettings.length > 0 && (
              <SliderRange
                value={this.state.selectedFieldsValue.sliderSettings || 0}
                min={0}
                max={64}
                onChange={(value) => {
                  this._changedSliderSettings(
                    this.state.selectedFields.sliderSettings,
                    value
                  );
                }}
              />
            )}
        </div>
      </div>
    );
  };

  _cornersOptions = (borderRadius, item, changeFunction) => {
    return (
      <div className="section">
        <div className="gk-form-row-container">
          <label className="small">{l("Corners")}</label>
          <button
            className={`dark gk-button gk-default gk-small gk-${this.state["showBorderRadius_" + item] ? "primary" : "secondary"
              }`}
            onClick={() => {
              this.setState({
                ["showBorderRadius_" + item]:
                  !this.state["showBorderRadius_" + item],
              });
            }}
          >
            <span>{l("Custom")}</span>
          </button>
        </div>
        {this.state["showBorderRadius_" + item] && (
          <div className="gk-corner-setter">
            {item !== "contentBorder" && (
              <div>
                <div>
                  <Icon
                    icon="corner"
                    className={`top-left ${borderRadius &&
                        borderRadius["lt"] &&
                        borderRadius["lt"] > 0
                        ? "active"
                        : ""
                      }`}
                  />
                  <Select
                    value={(borderRadius && borderRadius["lt"]) || 0}
                    onChange={(value) => {
                      changeFunction(item, "lt", value);
                    }}
                    options={[
                      { label: "--", value: 0 },
                      { label: "sm", value: 2 },
                      { label: "default", value: 4 },
                      { label: "md", value: 6 },
                      { label: "lg", value: 8 },
                      { label: "xl", value: 12 },
                      { label: "full", value: 9999 },
                    ]}
                    dark
                  />
                </div>
                <div>
                  <Select
                    value={(borderRadius && borderRadius["rt"]) || 0}
                    onChange={(value) => {
                      changeFunction(item, "rt", value);
                    }}
                    options={[
                      { label: "--", value: 0 },
                      { label: "sm", value: 2 },
                      { label: "default", value: 4 },
                      { label: "md", value: 6 },
                      { label: "lg", value: 8 },
                      { label: "xl", value: 12 },
                      { label: "full", value: 9999 },
                    ]}
                    dark
                  />
                  <Icon
                    icon="corner"
                    className={`top-right ${borderRadius &&
                        borderRadius["rt"] &&
                        borderRadius["rt"] > 0
                        ? "active"
                        : ""
                      }`}
                  />
                </div>
              </div>
            )}
            {item !== "tabBorder" &&
              item !== "activeTabBorder" &&
              item !== "inactiveTabBorder" && (
                <div>
                  <div>
                    <Icon
                      icon="corner"
                      className={`bottom-left ${borderRadius &&
                          borderRadius["lb"] &&
                          borderRadius["lb"] > 0
                          ? "active"
                          : ""
                        }`}
                    />
                    <Select
                      value={(borderRadius && borderRadius["lb"]) || 0}
                      onChange={(value) => {
                        changeFunction(item, "lb", value);
                      }}
                      options={[
                        { label: "--", value: 0 },
                        { label: "sm", value: 2 },
                        { label: "default", value: 4 },
                        { label: "md", value: 6 },
                        { label: "lg", value: 8 },
                        { label: "xl", value: 12 },
                        { label: "full", value: 9999 },
                      ]}
                      dark
                    />
                  </div>
                  <div>
                    <Select
                      value={(borderRadius && borderRadius["rb"]) || 0}
                      onChange={(value) => {
                        changeFunction(item, "rb", value);
                      }}
                      options={[
                        { label: "--", value: 0 },
                        { label: "sm", value: 2 },
                        { label: "default", value: 4 },
                        { label: "md", value: 6 },
                        { label: "lg", value: 8 },
                        { label: "xl", value: 12 },
                        { label: "full", value: 9999 },
                      ]}
                      dark
                    />
                    <Icon
                      icon="corner"
                      className={`bottom-right ${borderRadius &&
                          borderRadius["rb"] &&
                          borderRadius["rb"] > 0
                          ? "active"
                          : ""
                        }`}
                    />
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    );
  };

  _setDefauletSettings = (element = this.props.elementToEdit) => {
    const currentState = this.state;
    const { settings: currentSettings, datas: currentDatas } = currentState;

    const {
      payload: currentPayload,
      options: currentOptions,
      id,
      dropzoneID,
      parentID,
    } = element;
    const fullElement = state.getFullElement(id, dropzoneID, parentID);
    const fontSize = this._getThemeFont();
    const color = this._getThemeColor();

    const { options, payload } = fullElement;

    const availableSettings = options?.settings;

    const { settings: defaultSettings } = options?.payload;
    const { datas: defaultDatas, content: defaultContent } = payload;
    let newSettings = { ...defaultSettings };
    if (availableSettings?.text) {
      newSettings = {
        ...currentSettings,
        text: {
          ...currentSettings?.text,
          fontSize:  null,
          color: color || "",
        },
      };
    }

    state.updateElement(
      id,
      dropzoneID,
      parentID,
      {
        payload: {
          datas: defaultDatas,
          content: defaultContent,
          settings: newSettings,
        },
      },
      () => {
        this.setState({
          datas: defaultDatas,
          settings: newSettings,
        });
      }
    );
  };

  _getThemeColor = () => {
    var color = "";
    const headings = ["H1", "H2", "H3", "H4", "H5", "H6"];
    const { elementToEdit: element, settings } = this.props;
    const { elementId, name } = element;
    if (headings.includes(name)) {
      color = settings["heading_color"]?.color || "";
    } else {
      color = settings["body_color"]?.color || "";
    }
    return color;
  };

  _getThemeFont = () => {
    var font = 16;
    const headings = ["H1", "H2", "H3", "H4", "H5", "H6"];
    const { elementToEdit: element, settings } = this.props;
    const { name } = element;
    if (headings.includes(name)) {
      font = settings[name]?.size || 16;
    } else {
      font = settings["body"]?.size || 16;
    }
    return font;
  };

  _isUsingDefaultColor() {
    var font = null;
    const headings = ["H1", "H2", "H3", "H4", "H5", "H6"];
    const { elementToEdit: element, settings } = this.props;
    const { name } = element;
    if (headings.includes(name)) {
      font = settings["heading_color"]?.color || "";
    } else {
      font = settings["body_color"]?.color || 16;
    }
    return font;
  }

  _isUsingDefault() {
    const { settings: currentSettings } = this.state;
    const element = this.props.elementToEdit || {};
    const { options } = element || {};
    const { payload } = options || {};
    const { settings: defaultSettigns } = payload || {};

    const { text: defaultText } = defaultSettigns || {};
    const { text: currentText } = currentSettings || {};

    return isEqual(defaultText, currentText);
  }

  render() {
    const { elementToEdit: element } = this.props;
    const { settings, datas } = this.state;

    const {
      background: backgroundSettings,
      border,
      spacing: spacingSettings,
      text: textSettings,
      borderRadius,
      alignment,
      sliderSettings: settingsSliderSettings,
      imageSpacing,
    } = settings || {}; // CSS Settings

    const { sliderSettings: datasSliderSettings } = datas || {
      slider: [],
      sliderSettings: null,
    }; // Slider Settings

    const sliderSettings = {
      ...datasSliderSettings,
      ...settingsSliderSettings,
    };

    let { timerBgColor, timerColor } = datas || {}; // Products Countdown Timer Settings

    if (settings?.timerBgColor) {
      timerBgColor = settings?.timerBgColor;
    }
    if (settings?.timerColor) {
      timerColor = settings?.timerColor;
    }

    let {
      starPosition,
      color: starColor,
      size: starSize,
    } = settings?.starStyle || {}; // product star styles

    let {
      priceColor: pc,
      oldPriceColor: opc,
      pricePosition,
      priceSize,
    } = datas || {}; // Product list price settings

    const { priceStyles } = settings;
    if (priceStyles?.priceColor) {
      pc = priceStyles?.priceColor;
    }
    if (priceStyles?.oldPriceColor) {
      opc = priceStyles?.oldPriceColor;
    }
    if (priceStyles?.pricePosition) {
      pricePosition = priceStyles?.pricePosition;
    }
    if (priceStyles?.priceSize) {
      priceSize = priceStyles?.priceSize;
    }

    const { newsletterSettings: datasnewsletterSettings } = datas || {
      newsletterSettings: null,
    }; // Subscribe Newsletter Settings
    const { newsletterSettings: settingsnewsletterSettings, viewSettings={showInline:true} } =
      settings || {
        newsletterSettings: null,

      };

    const newsletterSettings = {
      ...datasnewsletterSettings,
      ...settingsnewsletterSettings,
      buttonIconPosition: datasnewsletterSettings?.buttonIconPosition,
    };

    const stepsSettings = {
      ...datas,
      ...settings,
    }; // Checkout steps settings

    const {
      nextStepBackgroundColor,
      previousStepBackgroundColor,
      currentStepBackgroundColor,
      nextStepTextColor,
      previousStepTextColor,
      currentStepTextColor,
    } = stepsSettings || {}; // Checkout steps settings

    const { hiddenDevices } = datas || {}; // Html Code

    const { imageCss } = settings || {}; // Product Image Css

    if (
      (this.props.alwaysOpenStyle || this.props.showBlockSettings) &&
      element
    ) {
      let availableSettings = {};

      if (
        element.elementId &&
        this.props.elementOptions[element.elementId] &&
        this.props.elementOptions[element.elementId].settings
      ) {
        availableSettings =
          this.props.elementOptions[element.elementId].settings;
      } else {
        availableSettings = this.props.elementToEdit?.options?.settings || {};
      }

      const iconsList = iconList;

      let currentDesignsDropdown = [];
      if (availableSettings.designSettings) {
        for (let i = 1; i <= availableSettings.designSettings; i++) {
          currentDesignsDropdown.push({
            label: l("Design") + " " + i,
            value: i,
          });
        }
      }

      if (availableSettings) {
        if (availableSettings.text) {
          const { text } = settings;
          if (
            text &&
            ((text?.fontSize &&
              text?.fontSize !== 16 &&
              text?.fontSize !== this._getThemeFont()) ||
              (text.color &&
                text.color !== "" &&
                text?.color !== this._isUsingDefaultColor())) &&
            !this.state.showAppearance
          ) {
            this.setState({ showAppearance: true });
          }
        }
        if (
          availableSettings.sliderTextSettings ||
          availableSettings.sliderLinkSettings
        ) {
          if (
            sliderSettings &&
            (sliderSettings.titleFontFamily ||
              sliderSettings.titleFontSize ||
              sliderSettings.titleFontWeight ||
              sliderSettings.titleColor ||
              sliderSettings.subtitleFontFamily ||
              sliderSettings.subtitleFontSize ||
              sliderSettings.subtitleFontWeight ||
              sliderSettings.subtitleColor ||
              sliderSettings.linkFontFamily ||
              sliderSettings.linkFontSize ||
              sliderSettings.linkBgColor ||
              sliderSettings.linkFontWeight ||
              sliderSettings.linkColor ||
              sliderSettings.testimonialFontFamily ||
              sliderSettings.testimonialFontSize ||
              sliderSettings.testimonialFontWeight ||
              sliderSettings.testimonialColor ||
              sliderSettings.titleTextAlign ||
              sliderSettings.subtitleTextAlign ||
              sliderSettings.linkTextAlign ||
              sliderSettings.testimonialTextAlign) &&
            !this.state.showAppearance
          ) {
            this.setState({ showAppearance: true });
          }
        }

        if (availableSettings.priceStyle) {
          const { priceStyles } = settings;
          if (
            priceStyles &&
            (priceStyles.priceColor ||
              priceStyles.oldPriceColor ||
              priceStyles.pricePosition ||
              priceStyles.priceSize) &&
            !this.state.showAppearance
          ) {
            this.setState({ showAppearance: true });
          }
        }
        if (availableSettings.productCountDownTimerSettings) {
          if ((timerBgColor || timerColor) && !this.state.showAppearance) {
            this.setState({ showAppearance: true });
          }
        }

        if (
          availableSettings.oldProductPricingSettings ||
          availableSettings.currentProductPricingSettings ||
          availableSettings.oldProductPricingLabelSettings ||
          availableSettings.currentProductPricingLabelSettings
        ) {
          const { productPricingSettings } = datas;
          if (
            productPricingSettings &&
            (productPricingSettings.labelBeforeOldPrice ||
              productPricingSettings.labelBeforeCurrentPrice ||
              Object.keys(productPricingSettings).length > 2) &&
            !this.state.showAppearance
          ) {
            this.setState({ showAppearance: true });
          }
        }
      }

      const {
        dividerLineWidth,
        dividerLineColor,
        dividerLineType,
        dividerSpacingTop,
        dividerSpacingBottom,
      } = settings.divider || {}; // divider options

      const {
        tabBorder,
        tabBackground,
        activeTabFont,
        activeTabBackground,
        activeTabBorder,
        inactiveTabFont,
        inactiveTabBorder,
        inactiveTabBackground,
        contentBorder,
        contentBackground,
        tabSpacing,
      } = settings || {}; // tabs settings

      return (
        <div className="block-settings">
          <div className="head-wraper">
            <div className="head">
              <Icon
                icon="time"
                onClick={() => {
                  this.props.editElement(null);
                  this.props.setShowBlockSettings(false);
                }}
              />
              <h3>{l(element.name)}</h3>
            </div>
            <ul className="tab-head">
              <li
                className={this.state.currentTab == 1 ? "active" : ""}
                onClick={() => {
                  this.setState({ currentTab: 1 });
                }}
              >
                {l("Style")}
              </li>
            </ul>
          </div>

          <div className="body">
            <div className="tab-settings">
              {availableSettings?.sliderItems && this.state.slideDialog && (
                <SlideDialog
                  slide={this.state.slideDialog}
                  onClose={() => {
                    this.setState({ slideDialog: null });
                  }}
                  onSave={(datas) => {
                    this._saveItem(datas, "slider", () => {
                      this.setState({ slideDialog: null });
                    });
                  }}
                  title={l("Edit item")}
                  isTestimonial={availableSettings?.sliderTestimonialSettings}
                />
              )}
              {availableSettings?.listSettings && this.state.listDatas && (
                <ListDialog
                  listDatas={this.state.listDatas}
                  listItems={
                    (this.state.datas && this.state.datas.listItems) || []
                  }
                  iconsList={iconsList}
                  onClose={() => {
                    this.setState({ listDatas: null });
                  }}
                  onSubmit={(datas) => {
                    this._saveItem(datas, "listItems", () => {
                      this.setState({ listDatas: null });
                    });
                  }}
                />
              )}

              {availableSettings?.message && (
                <div
                  className={
                    "gk-" + availableSettings?.message?.type + "-message"
                  }
                  style={{ margin: 10 }}
                >
                  <p>{availableSettings?.message?.content}</p>
                </div>
              )}

              {this.state.currentTab === 1 && (
                <ul
                  className={`settings-area ${hiddenDevices && hiddenDevices[this.props.currentDevice]
                      ? "disabled"
                      : ""
                    }`}
                >
                  <p className="alert-device uncolored">
                    {l("You are currently editing on")}{" "}
                    <Icon icon={`${this.props.currentDevice}-device`} />{" "}
                    <strong>
                      "{this.deviceLabel[this.props.currentDevice]}"
                    </strong>
                  </p>
                  {this.state.showAppearanceMessage &&
                    (this.state.showAppearance ? (
                      <>
                        <p className="gk-custom-message">
                          {l("Using settings from here")}{" "}
                        </p>
                        <div className="resetToDefault">
                          <button
                            onClick={() => {
                              this._setDefauletSettings(element);
                              this.setState({ showAppearance: false });
                            }}
                          >
                            <Icon icon="reset" />
                          </button>
                          <p>Reset to Theme Settings</p>
                        </div>
                      </>
                    ) : (
                      <>
                        <p className="alert-device uncolored">
                          {l("Element using theme settings")}{" "}
                          <Icon icon={"theme"} />
                        </p>
                      </>
                    ))}

                  <li className="uncolored">
                    <div className="body">
                      <div className="section">
                        <div className="gk-form-row-container">
                          <label className="small">
                            {l("Hide in")}{" "}
                            {this.deviceLabel[this.props.currentDevice]}
                          </label>
                          <Switch
                            checked={
                              (hiddenDevices &&
                                hiddenDevices[this.props.currentDevice]) ||
                              false
                            }
                            onChange={(e) => {
                              this._changedDatasTwo(
                                "hiddenDevices",
                                this.props.currentDevice,
                                e.target.checked
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="body">
                      <div className="section">
                        <div className="gk-form-row-container">
                          <label className="small">
                            Always open panel while edit.
                          </label>
                          <Switch
                            checked={this.props.alwaysOpenStyle}
                            onChange={(event) =>
                              this.props.setAlwasOpen(event.target.checked)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                  {hiddenDevices && hiddenDevices[this.props.currentDevice] && (
                    <div className="disabler"></div>
                  )}

                  {availableSettings.tabsStyle && (
                    <>
                      <li>
                        <div className="head">{l("Tab Head Border Style")}</div>
                        <div className="body">
                          {this._cornersOptions(
                            tabBorder,
                            "tabBorder",
                            this._changedSettingsTwo
                          )}
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    tabBorder && tabBorder.border_style === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    tabBorder &&
                                      tabBorder.border_style === "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    tabBorder &&
                                      tabBorder.border_style === "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    tabBorder &&
                                      tabBorder.border_style === "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Target")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target === "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>

                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>

                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                {tabBorder && tabBorder.border_target && (
                                  <Select
                                    value={
                                      (tabBorder && tabBorder.border_width) || 0
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_width",
                                        parseInt(value)
                                      );
                                    }}
                                    placeholder={l("Width")}
                                    options={[
                                      { label: "0", value: 0 },
                                      { label: "1", value: 1 },
                                      { label: "2", value: 2 },
                                      { label: "3", value: 3 },
                                      { label: "4", value: 4 },
                                      { label: "5", value: 5 },
                                      { label: "6", value: 6 },
                                      { label: "7", value: 7 },
                                      { label: "8", value: 8 },
                                      { label: "9", value: 9 },
                                    ]}
                                    dark
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            {tabBorder && tabBorder.border_target && (
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Border color")}
                                </label>
                                <div>
                                  <ColorSetter
                                    label={l("Border color")}
                                    color={
                                      (tabBorder && tabBorder.border_color) ||
                                      "#000000"
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_color",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Tab Head Background")}</div>
                        <div className="body">
                          <div className="section">
                            {!(
                              tabBackground && tabBackground.backgroundImage
                            ) && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background color")}
                                  </label>
                                  <NewColorPicker
                                    color={
                                      (tabBackground &&
                                        tabBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              )}
                            <ImageUploader
                              title={l("Image")}
                              withIcon={true}
                              buttonText={l("Upload image")}
                              onChange={(url) => {
                                this._changedSettingsTwo(
                                  "tabBackground",
                                  "backgroundImage",
                                  url
                                );
                              }}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                                ".webp",
                              ]}
                              maxFileSize={5242880}
                              withPreview={true}
                              defaultImages={
                                tabBackground &&
                                  tabBackground.backgroundImage !== undefined &&
                                  tabBackground.backgroundImage !== null
                                  ? tabBackground.backgroundImage
                                  : ""
                              }
                            />
                          </div>
                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Repeat")}</label>
                                <Select
                                  value={
                                    tabBackground.backgroundRepeat || "repeat"
                                  }
                                  onChange={(value) => {
                                    this._changedSettingsTwo(
                                      "tabBackground",
                                      "backgroundRepeat",
                                      value
                                    );
                                  }}
                                  options={[
                                    {
                                      label: l("Repeat"),
                                      value: "repeat",
                                    },
                                    {
                                      label: l("Repeat X"),
                                      value: "repeat-x",
                                    },
                                    {
                                      label: l("Repeat T"),
                                      value: "repeat-y",
                                    },
                                    {
                                      label: l("No repeat"),
                                      value: "no-repeat",
                                    },
                                  ]}
                                  dark
                                />
                              </div>
                            </div>
                          )}
                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Size")}</label>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      tabBackground.backgroundSize === "initial"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundSize",
                                        "initial"
                                      );
                                    }}
                                  >
                                    <span>{l("Auto")}</span>
                                  </li>
                                  <li
                                    className={
                                      tabBackground.backgroundSize === "cover"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundSize",
                                        "cover"
                                      );
                                    }}
                                  >
                                    <span>{l("Cover")}</span>
                                  </li>
                                  <li
                                    className={
                                      tabBackground.backgroundSize === "contain"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundSize",
                                        "contain"
                                      );
                                    }}
                                  >
                                    <span>{l("Contain")}</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}
                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Align")}</label>
                                <div className="gk-bg-align-box">
                                  <div>
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "left top"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-top-left"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "left top"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "center top"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-top-center"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "center top"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "right top"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-top-right"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "right top"
                                        );
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "left center"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-middle-left"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "left center"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "center center" ||
                                          !tabBackground.backgroundPosition
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-middle-center"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "center center"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "right center"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-middle-right"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "right center"
                                        );
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "left bottom"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-bottom-left"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "left bottom"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "center bottom"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-bottom-center"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "center bottom"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "right bottom"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-bottom-right"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "right bottom"
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Parallax background")}
                                </label>
                                <Switch
                                  checked={
                                    tabBackground && tabBackground.parallax
                                  }
                                  onChange={(e) => {
                                    this._changedSettingsTwo(
                                      "tabBackground",
                                      "parallax",
                                      e.target.checked
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </li>
                    </>
                  )}
                  {availableSettings.tabsStyle && (
                    <>
                      <li>
                        <div className="head">{l("Content Border Style")}</div>
                        <div className="body">
                          {this._cornersOptions(
                            contentBorder,
                            "contentBorder",
                            this._changedSettingsTwo
                          )}
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Target")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target === "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                {contentBorder && contentBorder.border_target && (
                                  <Select
                                    value={
                                      (contentBorder &&
                                        contentBorder.border_width) ||
                                      0
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_width",
                                        parseInt(value)
                                      );
                                    }}
                                    placeholder={l("Width")}
                                    options={[
                                      { label: "0", value: 0 },
                                      { label: "1", value: 1 },
                                      { label: "2", value: 2 },
                                      { label: "3", value: 3 },
                                      { label: "4", value: 4 },
                                      { label: "5", value: 5 },
                                      { label: "6", value: 6 },
                                      { label: "7", value: 7 },
                                      { label: "8", value: 8 },
                                      { label: "9", value: 9 },
                                    ]}
                                    dark
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            {contentBorder && contentBorder.border_target && (
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Border color")}
                                </label>
                                <div>
                                  <ColorSetter
                                    label={l("Border color")}
                                    color={
                                      (contentBorder &&
                                        contentBorder.border_color) ||
                                      "#000000"
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_color",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Content Background")}</div>
                        <div className="body">
                          <div className="section">
                            {!(
                              contentBackground &&
                              contentBackground.backgroundImage
                            ) && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background color")}
                                  </label>
                                  <NewColorPicker
                                    color={
                                      (contentBackground &&
                                        contentBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              )}
                            <ImageUploader
                              title={l("Image")}
                              withIcon={true}
                              buttonText={l("Upload image")}
                              onChange={(url) => {
                                this._changedSettingsTwo(
                                  "contentBackground",
                                  "backgroundImage",
                                  url
                                );
                              }}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                                ".webp",
                              ]}
                              maxFileSize={5242880}
                              withPreview={true}
                              defaultImages={
                                contentBackground &&
                                  contentBackground.backgroundImage !==
                                  undefined &&
                                  contentBackground.backgroundImage !== null
                                  ? contentBackground.backgroundImage
                                  : ""
                              }
                            />
                          </div>
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Repeat")}</label>
                                  <Select
                                    value={
                                      contentBackground.backgroundRepeat ||
                                      "repeat"
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "backgroundRepeat",
                                        value
                                      );
                                    }}
                                    options={[
                                      {
                                        label: l("Repeat"),
                                        value: "repeat",
                                      },
                                      {
                                        label: l("Repeat X"),
                                        value: "repeat-x",
                                      },
                                      {
                                        label: l("Repeat T"),
                                        value: "repeat-y",
                                      },
                                      {
                                        label: l("No repeat"),
                                        value: "no-repeat",
                                      },
                                    ]}
                                    dark
                                  />
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Size")}</label>
                                  <ul className="inline-options dark">
                                    <li
                                      className={
                                        contentBackground.backgroundSize ===
                                          "initial"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "contentBackground",
                                          "backgroundSize",
                                          "initial"
                                        );
                                      }}
                                    >
                                      <span>{l("Auto")}</span>
                                    </li>
                                    <li
                                      className={
                                        contentBackground.backgroundSize ===
                                          "cover"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "contentBackground",
                                          "backgroundSize",
                                          "cover"
                                        );
                                      }}
                                    >
                                      <span>{l("Cover")}</span>
                                    </li>
                                    <li
                                      className={
                                        contentBackground.backgroundSize ===
                                          "contain"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "contentBackground",
                                          "backgroundSize",
                                          "contain"
                                        );
                                      }}
                                    >
                                      <span>{l("Contain")}</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Align")}</label>
                                  <div className="gk-bg-align-box">
                                    <div>
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "left top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "left top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "center top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "center top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "right top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "right top"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "left center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "left center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "center center" ||
                                            !contentBackground.backgroundPosition
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "center center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "right center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "right center"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "left bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "left bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "center bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "center bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "right bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "right bottom"
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background overlay color")}
                                  </label>
                                  <ColorSetter
                                    color={
                                      (contentBackground &&
                                        contentBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <label className="small">
                                  {l("Background overlay opacity")} :
                                </label>
                                <SliderRange
                                  value={
                                    (contentBackground &&
                                      contentBackground.overlayOpacity) ||
                                    0
                                  }
                                  min={0}
                                  max={100}
                                  onChange={(value) => {
                                    this._changedSettingsTwo(
                                      "contentBackground",
                                      "overlayOpacity",
                                      value
                                    );
                                  }}
                                />
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Parallax background")}
                                  </label>
                                  <Switch
                                    checked={
                                      contentBackground &&
                                      contentBackground.parallax
                                    }
                                    onChange={(e) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "parallax",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      </li>
                    </>
                  )}
                  {availableSettings.tabsStyle && (
                    <>
                      <li>
                        <div className="head">{l("Active Tab Font Style")}</div>
                        <div className="body">
                          <div className="section">
                            <label className="small">{l("Size")}</label>
                            <SliderRange
                              value={
                                (activeTabFont && activeTabFont?.fontSize) ||
                                this._getThemeFont() ||
                                16
                              }
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "activeTabFont",
                                  "fontSize",
                                  value
                                );
                              }}
                            />
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">Font Color</label>
                              <ColorSetter
                                color={
                                  (activeTabFont && activeTabFont?.color) ||
                                  this._getThemeColor() ||
                                  ""
                                }
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "activeTabFont",
                                    "color",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Active Tab Border")}</div>
                        <div className="body">
                          {this._cornersOptions(
                            activeTabBorder,
                            "activeTabBorder",
                            this._changedSettingsTwo
                          )}
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    activeTabBorder &&
                                      activeTabBorder.border_style === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "activeTabBorder",
                                      "border_style",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    activeTabBorder &&
                                      activeTabBorder.border_style === "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "activeTabBorder",
                                      "border_style",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    activeTabBorder &&
                                      activeTabBorder.border_style === "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "activeTabBorder",
                                      "border_style",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    activeTabBorder &&
                                      activeTabBorder.border_style === "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "activeTabBorder",
                                      "border_style",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Target")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      activeTabBorder &&
                                        activeTabBorder.border_target === "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "activeTabBorder",
                                        "border_target",
                                        activeTabBorder &&
                                          activeTabBorder.border_target ===
                                          "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      activeTabBorder &&
                                        activeTabBorder.border_target ===
                                        "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "activeTabBorder",
                                        "border_target",
                                        activeTabBorder &&
                                          activeTabBorder.border_target ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>
                                  <li
                                    className={
                                      activeTabBorder &&
                                        activeTabBorder.border_target ===
                                        "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "activeTabBorder",
                                        "border_target",
                                        activeTabBorder &&
                                          activeTabBorder.border_target ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>
                                  <li
                                    className={
                                      activeTabBorder &&
                                        activeTabBorder.border_target ===
                                        "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "activeTabBorder",
                                        "border_target",
                                        activeTabBorder &&
                                          activeTabBorder.border_target ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      activeTabBorder &&
                                        activeTabBorder.border_target ===
                                        "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "activeTabBorder",
                                        "border_target",
                                        activeTabBorder &&
                                          activeTabBorder.border_target ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                {activeTabBorder &&
                                  activeTabBorder.border_target && (
                                    <Select
                                      value={
                                        (activeTabBorder &&
                                          activeTabBorder.border_width) ||
                                        0
                                      }
                                      onChange={(value) => {
                                        this._changedSettingsTwo(
                                          "activeTabBorder",
                                          "border_width",
                                          parseInt(value)
                                        );
                                      }}
                                      placeholder={l("Width")}
                                      options={[
                                        { label: "0", value: 0 },
                                        { label: "1", value: 1 },
                                        { label: "2", value: 2 },
                                        { label: "3", value: 3 },
                                        { label: "4", value: 4 },
                                        { label: "5", value: 5 },
                                        { label: "6", value: 6 },
                                        { label: "7", value: 7 },
                                        { label: "8", value: 8 },
                                        { label: "9", value: 9 },
                                      ]}
                                      dark
                                    />
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            {activeTabBorder && activeTabBorder.border_target && (
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Border color")}
                                </label>
                                <div>
                                  <ColorSetter
                                    label={l("Border color")}
                                    color={
                                      (activeTabBorder &&
                                        activeTabBorder.border_color) ||
                                      "#000000"
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "activeTabBorder",
                                        "border_color",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Active Tab Background")}</div>
                        <div className="body">
                          <div className="section">
                            {!(
                              activeTabBackground &&
                              activeTabBackground.backgroundImage
                            ) && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background color")}
                                  </label>
                                  <NewColorPicker
                                    color={
                                      (activeTabBackground &&
                                        activeTabBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "activeTabBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              )}
                            <ImageUploader
                              title={l("Image")}
                              withIcon={true}
                              buttonText={l("Upload image")}
                              onChange={(url) => {
                                this._changedSettingsTwo(
                                  "activeTabBackground",
                                  "backgroundImage",
                                  url
                                );
                              }}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                                ".webp",
                              ]}
                              maxFileSize={5242880}
                              withPreview={true}
                              defaultImages={
                                activeTabBackground &&
                                  activeTabBackground.backgroundImage !==
                                  undefined &&
                                  activeTabBackground.backgroundImage !== null
                                  ? activeTabBackground.backgroundImage
                                  : ""
                              }
                            />
                          </div>
                          {activeTabBackground &&
                            activeTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Repeat")}</label>
                                  <Select
                                    value={
                                      activeTabBackground.backgroundRepeat ||
                                      "repeat"
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "activeTabBackground",
                                        "backgroundRepeat",
                                        value
                                      );
                                    }}
                                    options={[
                                      {
                                        label: l("Repeat"),
                                        value: "repeat",
                                      },
                                      {
                                        label: l("Repeat X"),
                                        value: "repeat-x",
                                      },
                                      {
                                        label: l("Repeat T"),
                                        value: "repeat-y",
                                      },
                                      {
                                        label: l("No repeat"),
                                        value: "no-repeat",
                                      },
                                    ]}
                                    dark
                                  />
                                </div>
                              </div>
                            )}
                          {activeTabBackground &&
                            activeTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Size")}</label>
                                  <ul className="inline-options dark">
                                    <li
                                      className={
                                        activeTabBackground.backgroundSize ===
                                          "initial"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "activeTabBackground",
                                          "backgroundSize",
                                          "initial"
                                        );
                                      }}
                                    >
                                      <span>{l("Auto")}</span>
                                    </li>
                                    <li
                                      className={
                                        activeTabBackground.backgroundSize ===
                                          "cover"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "activeTabBackground",
                                          "backgroundSize",
                                          "cover"
                                        );
                                      }}
                                    >
                                      <span>{l("Cover")}</span>
                                    </li>
                                    <li
                                      className={
                                        activeTabBackground.backgroundSize ===
                                          "contain"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "activeTabBackground",
                                          "backgroundSize",
                                          "contain"
                                        );
                                      }}
                                    >
                                      <span>{l("Contain")}</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          {activeTabBackground &&
                            activeTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Align")}</label>
                                  <div className="gk-bg-align-box">
                                    <div>
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "left top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "left top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "center top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "center top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "right top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "right top"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "left center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "left center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "center center" ||
                                            !activeTabBackground.backgroundPosition
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "center center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "right center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "right center"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "left bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "left bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "center bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "center bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          activeTabBackground.backgroundPosition ==
                                            "right bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "activeTabBackground",
                                            "backgroundPosition",
                                            "right bottom"
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          {activeTabBackground &&
                            activeTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background overlay color")}
                                  </label>
                                  <ColorSetter
                                    color={
                                      (activeTabBackground &&
                                        activeTabBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "activeTabBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          {activeTabBackground &&
                            activeTabBackground.backgroundImage && (
                              <div className="section">
                                <label className="small">
                                  {l("Background overlay opacity")} :
                                </label>
                                <SliderRange
                                  value={
                                    (activeTabBackground &&
                                      activeTabBackground.overlayOpacity) ||
                                    0
                                  }
                                  min={0}
                                  max={100}
                                  onChange={(value) => {
                                    this._changedSettingsTwo(
                                      "activeTabBackground",
                                      "overlayOpacity",
                                      value
                                    );
                                  }}
                                />
                              </div>
                            )}
                          {activeTabBackground &&
                            activeTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Parallax background")}
                                  </label>
                                  <Switch
                                    checked={
                                      activeTabBackground &&
                                      activeTabBackground.parallax
                                    }
                                    onChange={(e) => {
                                      this._changedSettingsTwo(
                                        "activeTabBackground",
                                        "parallax",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      </li>
                    </>
                  )}
                  {availableSettings.tabsStyle && (
                    <>
                      <li>
                        <div className="head">
                          {l("Inactive Tab Font Style")}
                        </div>
                        <div className="body">
                          <div className="section">
                            <label className="small">{l("Size")}</label>
                            <SliderRange
                              value={
                                (inactiveTabFont &&
                                  inactiveTabFont?.fontSize) ||
                                this._getThemeFont() ||
                                16
                              }
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "inactiveTabFont",
                                  "fontSize",
                                  value
                                );
                              }}
                            />
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">Font Color</label>
                              <ColorSetter
                                color={
                                  (inactiveTabFont && inactiveTabFont?.color) ||
                                  this._getThemeColor() ||
                                  ""
                                }
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "inactiveTabFont",
                                    "color",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Inactive Tab Border")}</div>
                        <div className="body">
                          {this._cornersOptions(
                            inactiveTabBorder,
                            "inactiveTabBorder",
                            this._changedSettingsTwo
                          )}
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    inactiveTabBorder &&
                                      inactiveTabBorder.border_style === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "inactiveTabBorder",
                                      "border_style",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    inactiveTabBorder &&
                                      inactiveTabBorder.border_style === "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "inactiveTabBorder",
                                      "border_style",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    inactiveTabBorder &&
                                      inactiveTabBorder.border_style === "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "inactiveTabBorder",
                                      "border_style",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    inactiveTabBorder &&
                                      inactiveTabBorder.border_style === "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "inactiveTabBorder",
                                      "border_style",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Target")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      inactiveTabBorder &&
                                        inactiveTabBorder.border_target ===
                                        "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBorder",
                                        "border_target",
                                        inactiveTabBorder &&
                                          inactiveTabBorder.border_target ===
                                          "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      inactiveTabBorder &&
                                        inactiveTabBorder.border_target ===
                                        "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBorder",
                                        "border_target",
                                        inactiveTabBorder &&
                                          inactiveTabBorder.border_target ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>
                                  <li
                                    className={
                                      inactiveTabBorder &&
                                        inactiveTabBorder.border_target ===
                                        "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBorder",
                                        "border_target",
                                        inactiveTabBorder &&
                                          inactiveTabBorder.border_target ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>
                                  <li
                                    className={
                                      inactiveTabBorder &&
                                        inactiveTabBorder.border_target ===
                                        "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBorder",
                                        "border_target",
                                        inactiveTabBorder &&
                                          inactiveTabBorder.border_target ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      inactiveTabBorder &&
                                        inactiveTabBorder.border_target ===
                                        "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBorder",
                                        "border_target",
                                        inactiveTabBorder &&
                                          inactiveTabBorder.border_target ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                {inactiveTabBorder &&
                                  inactiveTabBorder.border_target && (
                                    <Select
                                      value={
                                        (inactiveTabBorder &&
                                          inactiveTabBorder.border_width) ||
                                        0
                                      }
                                      onChange={(value) => {
                                        this._changedSettingsTwo(
                                          "inactiveTabBorder",
                                          "border_width",
                                          parseInt(value)
                                        );
                                      }}
                                      placeholder={l("Width")}
                                      options={[
                                        { label: "0", value: 0 },
                                        { label: "1", value: 1 },
                                        { label: "2", value: 2 },
                                        { label: "3", value: 3 },
                                        { label: "4", value: 4 },
                                        { label: "5", value: 5 },
                                        { label: "6", value: 6 },
                                        { label: "7", value: 7 },
                                        { label: "8", value: 8 },
                                        { label: "9", value: 9 },
                                      ]}
                                      dark
                                    />
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            {inactiveTabBorder &&
                              inactiveTabBorder.border_target && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Border color")}
                                  </label>
                                  <div>
                                    <ColorSetter
                                      label={l("Border color")}
                                      color={
                                        (inactiveTabBorder &&
                                          inactiveTabBorder.border_color) ||
                                        "#000000"
                                      }
                                      onChangeComplete={(color) => {
                                        this._changedSettingsTwo(
                                          "inactiveTabBorder",
                                          "border_color",
                                          color
                                        );
                                      }}
                                      right
                                    />
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">
                          {l("Inactive Tab Background")}
                        </div>
                        <div className="body">
                          <div className="section">
                            {!(
                              inactiveTabBackground &&
                              inactiveTabBackground.backgroundImage
                            ) && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background color")}
                                  </label>
                                  <NewColorPicker
                                    color={
                                      (inactiveTabBackground &&
                                        inactiveTabBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              )}
                            <ImageUploader
                              title={l("Image")}
                              withIcon={true}
                              buttonText={l("Upload image")}
                              onChange={(url) => {
                                this._changedSettingsTwo(
                                  "inactiveTabBackground",
                                  "backgroundImage",
                                  url
                                );
                              }}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                                ".webp",
                              ]}
                              maxFileSize={5242880}
                              withPreview={true}
                              defaultImages={
                                inactiveTabBackground &&
                                  inactiveTabBackground.backgroundImage !==
                                  undefined &&
                                  inactiveTabBackground.backgroundImage !== null
                                  ? inactiveTabBackground.backgroundImage
                                  : ""
                              }
                            />
                          </div>
                          {inactiveTabBackground &&
                            inactiveTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Repeat")}</label>
                                  <Select
                                    value={
                                      inactiveTabBackground.backgroundRepeat ||
                                      "repeat"
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBackground",
                                        "backgroundRepeat",
                                        value
                                      );
                                    }}
                                    options={[
                                      {
                                        label: l("Repeat"),
                                        value: "repeat",
                                      },
                                      {
                                        label: l("Repeat X"),
                                        value: "repeat-x",
                                      },
                                      {
                                        label: l("Repeat T"),
                                        value: "repeat-y",
                                      },
                                      {
                                        label: l("No repeat"),
                                        value: "no-repeat",
                                      },
                                    ]}
                                    dark
                                  />
                                </div>
                              </div>
                            )}
                          {inactiveTabBackground &&
                            inactiveTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Size")}</label>
                                  <ul className="inline-options dark">
                                    <li
                                      className={
                                        inactiveTabBackground.backgroundSize ===
                                          "initial"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "inactiveTabBackground",
                                          "backgroundSize",
                                          "initial"
                                        );
                                      }}
                                    >
                                      <span>{l("Auto")}</span>
                                    </li>
                                    <li
                                      className={
                                        inactiveTabBackground.backgroundSize ===
                                          "cover"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "inactiveTabBackground",
                                          "backgroundSize",
                                          "cover"
                                        );
                                      }}
                                    >
                                      <span>{l("Cover")}</span>
                                    </li>
                                    <li
                                      className={
                                        inactiveTabBackground.backgroundSize ===
                                          "contain"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "inactiveTabBackground",
                                          "backgroundSize",
                                          "contain"
                                        );
                                      }}
                                    >
                                      <span>{l("Contain")}</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          {inactiveTabBackground &&
                            inactiveTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Align")}</label>
                                  <div className="gk-bg-align-box">
                                    <div>
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "left top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "left top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "center top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "center top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "right top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "right top"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "left center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "left center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "center center" ||
                                            !inactiveTabBackground.backgroundPosition
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "center center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "right center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "right center"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "left bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "left bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "center bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "center bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          inactiveTabBackground.backgroundPosition ==
                                            "right bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "inactiveTabBackground",
                                            "backgroundPosition",
                                            "right bottom"
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          {inactiveTabBackground &&
                            inactiveTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background overlay color")}
                                  </label>
                                  <ColorSetter
                                    color={
                                      (inactiveTabBackground &&
                                        inactiveTabBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          {inactiveTabBackground &&
                            inactiveTabBackground.backgroundImage && (
                              <div className="section">
                                <label className="small">
                                  {l("Background overlay opacity")} :
                                </label>
                                <SliderRange
                                  value={
                                    (inactiveTabBackground &&
                                      inactiveTabBackground.overlayOpacity) ||
                                    0
                                  }
                                  min={0}
                                  max={100}
                                  onChange={(value) => {
                                    this._changedSettingsTwo(
                                      "inactiveTabBackground",
                                      "overlayOpacity",
                                      value
                                    );
                                  }}
                                />
                              </div>
                            )}
                          {inactiveTabBackground &&
                            inactiveTabBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Parallax background")}
                                  </label>
                                  <Switch
                                    checked={
                                      inactiveTabBackground &&
                                      inactiveTabBackground.parallax
                                    }
                                    onChange={(e) => {
                                      this._changedSettingsTwo(
                                        "inactiveTabBackground",
                                        "parallax",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      </li>
                    </>
                  )}
                  {availableSettings.collapseSettings && (
                    <>
                      <li>
                        <div className="head">{l("Heading Border")}</div>
                        <div className="body">
                          {this._cornersOptions(
                            tabBorder,
                            "tabBorder",
                            this._changedSettingsTwo
                          )}
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    tabBorder && tabBorder.border_style === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    tabBorder &&
                                      tabBorder.border_style === "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    tabBorder &&
                                      tabBorder.border_style === "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    tabBorder &&
                                      tabBorder.border_style === "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "tabBorder",
                                      "border_style",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Target")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target === "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>
                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>

                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      tabBorder &&
                                        tabBorder.border_target === "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_target",
                                        tabBorder &&
                                          tabBorder.border_target ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                {tabBorder && tabBorder.border_target && (
                                  <Select
                                    value={
                                      (tabBorder && tabBorder.border_width) || 0
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_width",
                                        parseInt(value)
                                      );
                                    }}
                                    placeholder={l("Width")}
                                    options={[
                                      { label: "0", value: 0 },
                                      { label: "1", value: 1 },
                                      { label: "2", value: 2 },
                                      { label: "3", value: 3 },
                                      { label: "4", value: 4 },
                                      { label: "5", value: 5 },
                                      { label: "6", value: 6 },
                                      { label: "7", value: 7 },
                                      { label: "8", value: 8 },
                                      { label: "9", value: 9 },
                                    ]}
                                    dark
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            {tabBorder && tabBorder.border_target && (
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Border color")}
                                </label>
                                <div>
                                  <ColorSetter
                                    label={l("Border color")}
                                    color={
                                      (tabBorder && tabBorder.border_color) ||
                                      "#000000"
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "tabBorder",
                                        "border_color",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Heading Background")}</div>
                        <div className="body">
                          <div className="section">
                            {!(
                              tabBackground && tabBackground.backgroundImage
                            ) && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background color")}
                                  </label>
                                  <NewColorPicker
                                    color={
                                      (tabBackground &&
                                        tabBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              )}
                            <ImageUploader
                              title={l("Image")}
                              withIcon={true}
                              buttonText={l("Upload image")}
                              onChange={(url) => {
                                this._changedSettingsTwo(
                                  "tabBackground",
                                  "backgroundImage",
                                  url
                                );
                              }}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                                ".webp",
                              ]}
                              maxFileSize={5242880}
                              withPreview={true}
                              defaultImages={
                                tabBackground &&
                                  tabBackground.backgroundImage !== undefined &&
                                  tabBackground.backgroundImage !== null
                                  ? tabBackground.backgroundImage
                                  : ""
                              }
                            />
                          </div>
                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Repeat")}</label>
                                <Select
                                  value={
                                    tabBackground.backgroundRepeat || "repeat"
                                  }
                                  onChange={(value) => {
                                    this._changedSettingsTwo(
                                      "tabBackground",
                                      "backgroundRepeat",
                                      value
                                    );
                                  }}
                                  options={[
                                    {
                                      label: l("Repeat"),
                                      value: "repeat",
                                    },
                                    {
                                      label: l("Repeat X"),
                                      value: "repeat-x",
                                    },
                                    {
                                      label: l("Repeat T"),
                                      value: "repeat-y",
                                    },
                                    {
                                      label: l("No repeat"),
                                      value: "no-repeat",
                                    },
                                  ]}
                                  dark
                                />
                              </div>
                            </div>
                          )}
                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Size")}</label>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      tabBackground.backgroundSize === "initial"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundSize",
                                        "initial"
                                      );
                                    }}
                                  >
                                    <span>{l("Auto")}</span>
                                  </li>
                                  <li
                                    className={
                                      tabBackground.backgroundSize === "cover"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundSize",
                                        "cover"
                                      );
                                    }}
                                  >
                                    <span>{l("Cover")}</span>
                                  </li>
                                  <li
                                    className={
                                      tabBackground.backgroundSize === "contain"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "tabBackground",
                                        "backgroundSize",
                                        "contain"
                                      );
                                    }}
                                  >
                                    <span>{l("Contain")}</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}
                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Align")}</label>
                                <div className="gk-bg-align-box">
                                  <div>
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "left top"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-top-left"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "left top"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "center top"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-top-center"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "center top"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "right top"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-top-right"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "right top"
                                        );
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "left center"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-middle-left"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "left center"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "center center" ||
                                          !tabBackground.backgroundPosition
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-middle-center"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "center center"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "right center"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-middle-right"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "right center"
                                        );
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "left bottom"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-bottom-left"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "left bottom"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "center bottom"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-bottom-center"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "center bottom"
                                        );
                                      }}
                                    />
                                    <Icon
                                      className={
                                        tabBackground.backgroundPosition ==
                                          "right bottom"
                                          ? "active"
                                          : ""
                                      }
                                      icon="align-bottom-right"
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "tabBackground",
                                          "backgroundPosition",
                                          "right bottom"
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {tabBackground && tabBackground.backgroundImage && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Parallax background")}
                                </label>
                                <Switch
                                  checked={
                                    tabBackground && tabBackground.parallax
                                  }
                                  onChange={(e) => {
                                    this._changedSettingsTwo(
                                      "tabBackground",
                                      "parallax",
                                      e.target.checked
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Content Border Style")}</div>
                        <div className="body">
                          {this._cornersOptions(
                            contentBorder,
                            "contentBorder",
                            this._changedSettingsTwo
                          )}
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    contentBorder &&
                                      contentBorder.border_style === "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "contentBorder",
                                      "border_style",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Target")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target === "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      contentBorder &&
                                        contentBorder.border_target ===
                                        "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_target",
                                        contentBorder &&
                                          contentBorder.border_target ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                {contentBorder && contentBorder.border_target && (
                                  <Select
                                    value={
                                      (contentBorder &&
                                        contentBorder.border_width) ||
                                      0
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_width",
                                        parseInt(value)
                                      );
                                    }}
                                    placeholder={l("Width")}
                                    options={[
                                      { label: "0", value: 0 },
                                      { label: "1", value: 1 },
                                      { label: "2", value: 2 },
                                      { label: "3", value: 3 },
                                      { label: "4", value: 4 },
                                      { label: "5", value: 5 },
                                      { label: "6", value: 6 },
                                      { label: "7", value: 7 },
                                      { label: "8", value: 8 },
                                      { label: "9", value: 9 },
                                    ]}
                                    dark
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            {contentBorder && contentBorder.border_target && (
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Border color")}
                                </label>
                                <div>
                                  <ColorSetter
                                    label={l("Border color")}
                                    color={
                                      (contentBorder &&
                                        contentBorder.border_color) ||
                                      "#000000"
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "contentBorder",
                                        "border_color",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="head">{l("Content Background")}</div>
                        <div className="body">
                          <div className="section">
                            {!(
                              contentBackground &&
                              contentBackground.backgroundImage
                            ) && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background color")}
                                  </label>
                                  <NewColorPicker
                                    color={
                                      (contentBackground &&
                                        contentBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              )}
                            <ImageUploader
                              title={l("Image")}
                              withIcon={true}
                              buttonText={l("Upload image")}
                              onChange={(url) => {
                                this._changedSettingsTwo(
                                  "contentBackground",
                                  "backgroundImage",
                                  url
                                );
                              }}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                                ".webp",
                              ]}
                              maxFileSize={5242880}
                              withPreview={true}
                              defaultImages={
                                contentBackground &&
                                  contentBackground.backgroundImage !==
                                  undefined &&
                                  contentBackground.backgroundImage !== null
                                  ? contentBackground.backgroundImage
                                  : ""
                              }
                            />
                          </div>
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Repeat")}</label>
                                  <Select
                                    value={
                                      contentBackground.backgroundRepeat ||
                                      "repeat"
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "backgroundRepeat",
                                        value
                                      );
                                    }}
                                    options={[
                                      {
                                        label: l("Repeat"),
                                        value: "repeat",
                                      },
                                      {
                                        label: l("Repeat X"),
                                        value: "repeat-x",
                                      },
                                      {
                                        label: l("Repeat T"),
                                        value: "repeat-y",
                                      },
                                      {
                                        label: l("No repeat"),
                                        value: "no-repeat",
                                      },
                                    ]}
                                    dark
                                  />
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Size")}</label>
                                  <ul className="inline-options dark">
                                    <li
                                      className={
                                        contentBackground.backgroundSize ===
                                          "initial"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "contentBackground",
                                          "backgroundSize",
                                          "initial"
                                        );
                                      }}
                                    >
                                      <span>{l("Auto")}</span>
                                    </li>
                                    <li
                                      className={
                                        contentBackground.backgroundSize ===
                                          "cover"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "contentBackground",
                                          "backgroundSize",
                                          "cover"
                                        );
                                      }}
                                    >
                                      <span>{l("Cover")}</span>
                                    </li>
                                    <li
                                      className={
                                        contentBackground.backgroundSize ===
                                          "contain"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "contentBackground",
                                          "backgroundSize",
                                          "contain"
                                        );
                                      }}
                                    >
                                      <span>{l("Contain")}</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">{l("Align")}</label>
                                  <div className="gk-bg-align-box">
                                    <div>
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "left top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "left top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "center top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "center top"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "right top"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-top-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "right top"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "left center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "left center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "center center" ||
                                            !contentBackground.backgroundPosition
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "center center"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "right center"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-middle-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "right center"
                                          );
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "left bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-left"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "left bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "center bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-center"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "center bottom"
                                          );
                                        }}
                                      />
                                      <Icon
                                        className={
                                          contentBackground.backgroundPosition ==
                                            "right bottom"
                                            ? "active"
                                            : ""
                                        }
                                        icon="align-bottom-right"
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "contentBackground",
                                            "backgroundPosition",
                                            "right bottom"
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Background overlay color")}
                                  </label>
                                  <ColorSetter
                                    color={
                                      (contentBackground &&
                                        contentBackground.backgroundColor) ||
                                      ""
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "backgroundColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <label className="small">
                                  {l("Background overlay opacity")} :
                                </label>
                                <SliderRange
                                  value={
                                    (contentBackground &&
                                      contentBackground.overlayOpacity) ||
                                    0
                                  }
                                  min={0}
                                  max={100}
                                  onChange={(value) => {
                                    this._changedSettingsTwo(
                                      "contentBackground",
                                      "overlayOpacity",
                                      value
                                    );
                                  }}
                                />
                              </div>
                            )}
                          {contentBackground &&
                            contentBackground.backgroundImage && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Parallax background")}
                                  </label>
                                  <Switch
                                    checked={
                                      contentBackground &&
                                      contentBackground.parallax
                                    }
                                    onChange={(e) => {
                                      this._changedSettingsTwo(
                                        "contentBackground",
                                        "parallax",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      </li>
                    </>
                  )}
                  {(availableSettings.tabsStyle ||
                    availableSettings.collapseSettings) && (
                      <>
                        <li>
                          <div className="head">
                            {l(
                              (availableSettings.tabsStyle ? "Tab" : "Heading") +
                              " Spacing"
                            )}
                          </div>
                          <div className="body">
                            <HoverSpacer
                              item="tabSpacing"
                              spacingSettings={tabSpacing}
                              onChange={this._changedSettingsTwo}
                            />
                          </div>
                        </li>
                      </>
                    )}
                  {availableSettings.imageCss && (
                    <>
                      <li>
                        <div className="head">{l("Image Styles")}</div>
                        <div className="body">
                          {this._cornersOptions(
                            imageCss?.imageCornerRadius,
                            "imageCornerRadius",
                            (...data) => {
                              const radius = {
                                ...imageCss?.imageCornerRadius,
                                [data[1]]: data[2],
                              };

                              this._changedSettingsTwo(
                                "imageCss",
                                "imageCornerRadius",
                                radius
                              );
                            }
                          )}
                        </div>
                        <div className="body">
                          <div className="section">
                            <div className="spacing-area">
                              <div className="top">
                                <div>
                                  <input
                                    type="text"
                                    readOnly
                                    onClick={() => {
                                      this._setSelectedField(
                                        "settings",
                                        "imageSpacing",
                                        "marginTop",
                                        (imageSpacing &&
                                          imageSpacing.marginTop) ||
                                        0
                                      );
                                    }}
                                    className={
                                      this.state.selectedFields.imageSpacing &&
                                        inArray(
                                          "marginTop",
                                          this.state.selectedFields.imageSpacing
                                        )
                                        ? "active"
                                        : ""
                                    }
                                    value={
                                      (imageSpacing &&
                                        imageSpacing.marginTop) ||
                                      0
                                    }
                                  />
                                </div>
                              </div>
                              <div className="middle">
                                <div>
                                  <input
                                    type="text"
                                    readOnly
                                    onClick={() => {
                                      this._setSelectedField(
                                        "settings",
                                        "imageSpacing",
                                        "marginLeft",
                                        (imageSpacing &&
                                          imageSpacing.marginLeft) ||
                                        0
                                      );
                                    }}
                                    className={
                                      this.state.selectedFields.imageSpacing &&
                                        inArray(
                                          "marginLeft",
                                          this.state.selectedFields.imageSpacing
                                        )
                                        ? "active"
                                        : ""
                                    }
                                    value={
                                      (imageSpacing &&
                                        imageSpacing.marginLeft) ||
                                      0
                                    }
                                  />
                                </div>
                                <div>
                                  <div>
                                    <span className="padding">
                                      {l("Padding")}
                                    </span>
                                    <input
                                      type="text"
                                      readOnly
                                      onClick={() => {
                                        this._setSelectedField(
                                          "settings",
                                          "imageSpacing",
                                          "paddingLeft",
                                          (spacingSettings &&
                                            spacingSettings.paddingLeft) ||
                                          0
                                        );
                                      }}
                                      className={
                                        this.state.selectedFields
                                          .imageSpacing &&
                                          inArray(
                                            "paddingLeft",
                                            this.state.selectedFields.imageSpacing
                                          )
                                          ? "active"
                                          : ""
                                      }
                                      value={
                                        (imageSpacing &&
                                          imageSpacing.paddingLeft) ||
                                        0
                                      }
                                    />
                                  </div>
                                  <div>
                                    <div>
                                      <input
                                        type="text"
                                        readOnly
                                        onClick={() => {
                                          this._setSelectedField(
                                            "settings",
                                            "imageSpacing",
                                            "paddingTop",
                                            (imageSpacing &&
                                              imageSpacing.paddingTop) ||
                                            0
                                          );
                                        }}
                                        className={
                                          this.state.selectedFields
                                            .imageSpacing &&
                                            inArray(
                                              "paddingTop",
                                              this.state.selectedFields
                                                .imageSpacing
                                            )
                                            ? "active"
                                            : ""
                                        }
                                        value={
                                          (imageSpacing &&
                                            imageSpacing.paddingTop) ||
                                          0
                                        }
                                      />
                                    </div>
                                    <div></div>
                                    <div>
                                      <input
                                        type="text"
                                        readOnly
                                        onClick={() => {
                                          this._setSelectedField(
                                            "settings",
                                            "imageSpacing",
                                            "paddingBottom",
                                            (imageSpacing &&
                                              imageSpacing.paddingBottom) ||
                                            0
                                          );
                                        }}
                                        className={
                                          this.state.selectedFields
                                            .imageSpacing &&
                                            inArray(
                                              "paddingBottom",
                                              this.state.selectedFields
                                                .imageSpacing
                                            )
                                            ? "active"
                                            : ""
                                        }
                                        value={
                                          (imageSpacing &&
                                            imageSpacing.paddingBottom) ||
                                          0
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <input
                                      type="text"
                                      readOnly
                                      onClick={() => {
                                        this._setSelectedField(
                                          "settings",
                                          "imageSpacing",
                                          "paddingRight",
                                          (imageSpacing &&
                                            imageSpacing.paddingRight) ||
                                          0
                                        );
                                      }}
                                      className={
                                        this.state.selectedFields
                                          .imageSpacing &&
                                          inArray(
                                            "paddingRight",
                                            this.state.selectedFields.imageSpacing
                                          )
                                          ? "active"
                                          : ""
                                      }
                                      value={
                                        (imageSpacing &&
                                          imageSpacing.paddingRight) ||
                                        0
                                      }
                                    />
                                  </div>
                                </div>
                                <div>
                                  <input
                                    type="text"
                                    readOnly
                                    onClick={() => {
                                      this._setSelectedField(
                                        "settings",
                                        "imageSpacing",
                                        "marginRight",
                                        (imageSpacing &&
                                          imageSpacing.marginRight) ||
                                        0
                                      );
                                    }}
                                    className={
                                      this.state.selectedFields.imageSpacing &&
                                        inArray(
                                          "marginRight",
                                          this.state.selectedFields.imageSpacing
                                        )
                                        ? "active"
                                        : ""
                                    }
                                    value={
                                      (imageSpacing &&
                                        imageSpacing.marginRight) ||
                                      0
                                    }
                                  />
                                </div>
                              </div>
                              <div className="bottom">
                                <div>
                                  <span className="margin">{l("Margin")}</span>
                                  <input
                                    type="text"
                                    readOnly
                                    onClick={() => {
                                      this._setSelectedField(
                                        "settings",
                                        "imageSpacing",
                                        "marginBottom",
                                        (imageSpacing &&
                                          imageSpacing.marginBottom) ||
                                        0
                                      );
                                    }}
                                    className={
                                      this.state.selectedFields.imageSpacing &&
                                        inArray(
                                          "marginBottom",
                                          this.state.selectedFields.imageSpacing
                                        )
                                        ? "active"
                                        : ""
                                    }
                                    value={
                                      (imageSpacing &&
                                        imageSpacing.marginBottom) ||
                                      0
                                    }
                                  />
                                </div>
                              </div>
                              <div className="gk-ray a"></div>
                              <div className="gk-ray b"></div>
                            </div>
                            {this.state.selectedFields.imageSpacing &&
                              this.state.selectedFields.imageSpacing.length >
                              0 && (
                                <SliderRange
                                  value={
                                    this.state.selectedFieldsValue
                                      .imageSpacing || 0
                                  }
                                  min={
                                    inArray(
                                      "paddingLeft",
                                      this.state.selectedFields.imageSpacing
                                    ) ||
                                      inArray(
                                        "paddingTop",
                                        this.state.selectedFields.imageSpacing
                                      ) ||
                                      inArray(
                                        "paddingBottom",
                                        this.state.selectedFields.imageSpacing
                                      ) ||
                                      inArray(
                                        "paddingRight",
                                        this.state.selectedFields.imageSpacing
                                      )
                                      ? 0
                                      : -300
                                  }
                                  max={300}
                                  onChange={(value) => {
                                    this._changedSettingsTwo(
                                      "imageSpacing",
                                      this.state.selectedFields.imageSpacing,
                                      value
                                    );
                                  }}
                                />
                              )}
                            {this.state.selectedFields.imageSpacing &&
                              this.state.selectedFields.imageSpacing.length >
                              0 &&
                              !(
                                inArray(
                                  "paddingLeft",
                                  this.state.selectedFields.imageSpacing
                                ) ||
                                inArray(
                                  "paddingTop",
                                  this.state.selectedFields.imageSpacing
                                ) ||
                                inArray(
                                  "paddingBottom",
                                  this.state.selectedFields.imageSpacing
                                ) ||
                                inArray(
                                  "paddingRight",
                                  this.state.selectedFields.imageSpacing
                                )
                              ) && (
                                <span className="ultrasmall-alert">
                                  {l("You can set negative value")}
                                </span>
                              )}
                          </div>
                        </div>
                        <div className="body">
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">
                                {l("Shadow Color")}
                              </label>
                              <ColorSetter
                                color={imageCss?.imageBoxShadow?.color || ""}
                                onChangeComplete={(color) => {
                                  const imageBoxShadowCss = {
                                    ...imageCss?.imageBoxShadow,
                                    color: color,
                                  };

                                  this._changedSettingsTwo(
                                    "imageCss",
                                    "imageBoxShadow",
                                    imageBoxShadowCss
                                  );
                                }}
                                right
                              />
                            </div>

                            <label className="small">
                              {l("Shadow X offset")}
                            </label>
                            <SliderRange
                              value={
                                (imageCss &&
                                  imageCss?.imageBoxShadow?.xOffset) ||
                                0
                              }
                              min={0}
                              max={100}
                              onChange={(value) => {
                                const imageBoxShadowCss = {
                                  ...imageCss?.imageBoxShadow,
                                  xOffset: value,
                                };

                                this._changedSettingsTwo(
                                  "imageCss",
                                  "imageBoxShadow",
                                  imageBoxShadowCss
                                );
                              }}
                            />

                            <label className="small">
                              {l("Shadow Y offset")}
                            </label>
                            <SliderRange
                              value={
                                (imageCss &&
                                  imageCss?.imageBoxShadow?.yOffset) ||
                                0
                              }
                              min={0}
                              max={100}
                              onChange={(value) => {
                                const imageBoxShadowCss = {
                                  ...imageCss?.imageBoxShadow,
                                  yOffset: value,
                                };

                                this._changedSettingsTwo(
                                  "imageCss",
                                  "imageBoxShadow",
                                  imageBoxShadowCss
                                );
                              }}
                            />

                            <label className="small">{l("Shadow Blur")}</label>
                            <SliderRange
                              value={
                                (imageCss && imageCss?.imageBoxShadow?.blur) ||
                                0
                              }
                              min={0}
                              max={100}
                              onChange={(value) => {
                                const imageBoxShadowCss = {
                                  ...imageCss?.imageBoxShadow,
                                  blur: value,
                                };

                                this._changedSettingsTwo(
                                  "imageCss",
                                  "imageBoxShadow",
                                  imageBoxShadowCss
                                );
                              }}
                            />

                            <label className="small">
                              {l("Shadow Spread")}
                            </label>
                            <SliderRange
                              value={
                                (imageCss &&
                                  imageCss?.imageBoxShadow?.spread) ||
                                0
                              }
                              min={0}
                              max={100}
                              onChange={(value) => {
                                const imageBoxShadowCss = {
                                  ...imageCss?.imageBoxShadow,
                                  spread: value,
                                };

                                this._changedSettingsTwo(
                                  "imageCss",
                                  "imageBoxShadow",
                                  imageBoxShadowCss
                                );
                              }}
                            />
                          </div>
                        </div>
                      </li>
                      <li></li>
                    </>
                  )}

                  {!availableSettings?.text &&
                    (element?.type == "category_description" ||
                      element?.type == "product_description" ||
                      element?.type == "upsell_product_upsell_description" ||
                      element?.type == "upsell_product_description") && (
                      <div className="body">
                        <div className="gk-custom-message">
                          Description styling is shown exactly like it was set
                          up on Product Page
                        </div>
                      </div>
                    )}

                  {availableSettings?.text && (
                    <li>
                      <div className="head">
                        {availableSettings?.text?.title || l("Text Style")}
                      </div>

                      <div className="body">
                        {availableSettings.productCountDownTimerSettings && (
                          <>
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Background color")}
                                </label>
                                <ColorSetter
                                  color={timerBgColor || "#3b5998"}
                                  onChangeComplete={(color) => {
                                    this._changedSettingsOne(
                                      "timerBgColor",
                                      color
                                    );
                                  }}
                                  right
                                />
                              </div>
                            </div>
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Text color")}
                                </label>
                                <ColorSetter
                                  color={timerColor || "#FFFFFF"}
                                  onChangeComplete={(color) => {
                                    this._changedSettingsOne(
                                      "timerColor",
                                      color
                                    );
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          </>
                        )}
                        {availableSettings?.text?.fontSize && (
                          <div className="section">
                            <label className="small">{l("Size")}</label>
                            <SliderRange
                              value={
                                (textSettings && textSettings?.fontSize) ||
                                this._getThemeFont() ||
                                16
                              }
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "text",
                                  "fontSize",
                                  value
                                );
                              }}
                            />
                          </div>
                        )}

                        {availableSettings?.text?.textAlign && (
                          <div className="section">
                            <ul className="inline-options dark grow">
                              <li
                                className={
                                  textSettings &&
                                    textSettings.textAlign === "left"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "text",
                                    "textAlign",
                                    "left"
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={["fa", "align-left"]} />
                              </li>
                              <li
                                className={
                                  textSettings &&
                                    textSettings.textAlign === "center"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "text",
                                    "textAlign",
                                    "center"
                                  );
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={["fa", "align-center"]}
                                />
                              </li>
                              <li
                                className={
                                  textSettings &&
                                    textSettings.textAlign === "right"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "text",
                                    "textAlign",
                                    "right"
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={["fa", "align-right"]} />
                              </li>
                              <li
                                className={
                                  textSettings &&
                                    textSettings.textAlign === "justify"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "text",
                                    "textAlign",
                                    "justify"
                                  );
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={["fa", "align-justify"]}
                                />
                              </li>
                            </ul>
                          </div>
                        )}
                        <div className="section">
                          {availableSettings.text.fontFamily && (
                            <ul className="text-decor">
                              <Select
                                value={
                                  (textSettings && textSettings.fontWeight) ||
                                  ""
                                }
                                onChange={(value) => {
                                  this._changedSettingsTwo(
                                    "text",
                                    "fontWeight",
                                    value
                                  );
                                }}
                                placeholder={l("Font weight")}
                                options={this._fontsWeightOptions(
                                  (textSettings && textSettings.fontFamilyId) ||
                                  "",
                                  (textSettings && textSettings.fontFamily) ||
                                  ""
                                )}
                                dark
                              />
                              <li
                                onClick={() => {
                                  if (textSettings?.fontWeight != 600)
                                    this._changedSettingsTwo(
                                      "text",
                                      "fontWeight",
                                      600
                                    );
                                  else
                                    this._changedSettingsTwo(
                                      "text",
                                      "fontWeight",
                                      200
                                    );
                                }}
                                className={`${textSettings?.fontWeight === 600
                                    ? "selected"
                                    : ""
                                  }`}
                              >
                                <Icon icon="bold" />
                              </li>
                              <li
                                onClick={() => {
                                  textSettings?.fontStyle === "italic"
                                    ? this._changedSettingsTwo(
                                      "text",
                                      "fontStyle",
                                      "normal"
                                    )
                                    : this._changedSettingsTwo(
                                      "text",
                                      "fontStyle",
                                      "italic"
                                    );
                                }}
                                className={`${textSettings?.fontStyle === "italic"
                                    ? "selected"
                                    : ""
                                  }`}
                              >
                                <Icon icon="italic" />
                              </li>
                              <li
                                onClick={() => {
                                  textSettings?.textDecorationLine ===
                                    "underline"
                                    ? this._changedSettingsTwo(
                                      "text",
                                      "textDecorationLine",
                                      "none"
                                    )
                                    : this._changedSettingsTwo(
                                      "text",
                                      "textDecorationLine",
                                      "underline"
                                    );
                                }}
                                className={`${textSettings?.textDecorationLine ===
                                    "underline"
                                    ? "selected"
                                    : ""
                                  }`}
                              >
                                <Icon icon="underline" />
                              </li>
                            </ul>
                          )}
                          {availableSettings?.text?.color && (
                            <>
                              <div className="gk-form-row-container">
                                <label className="small">Font Color</label>
                                <ColorSetter
                                  color={
                                    (textSettings && textSettings?.color) ||
                                    this._getThemeColor() ||
                                    ""
                                  }
                                  onChangeComplete={(color) => {
                                    this._changedSettingsTwo(
                                      "text",
                                      "color",
                                      color
                                    );
                                  }}
                                  right
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings?.starStyle && (
                    <li>
                      <div className="head">{l("Star Styles")}</div>
                      <div className="body">
                        <div className="section">
                          <>
                            <div className="gk-form-row-container">
                              <label className="small">Star Color</label>
                              <ColorSetter
                                color={starColor || ""}
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "starStyle",
                                    "color",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings?.alignment && (
                    <li>
                      <div className="head">{l("Block Alignment")}</div>
                      <div className="body">
                        <div className="section">
                          <ul className="inline-options dark grow">
                            <li
                              onClick={() => {
                                this._changedSettingsOne("alignment", "left");
                              }}
                              className={
                                !alignment ||
                                  (alignment && alignment === "left")
                                  ? "selected"
                                  : ""
                              }
                            >
                              <span>{l("Left")}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedSettingsOne("alignment", "center");
                              }}
                              className={
                                alignment && alignment === "center"
                                  ? "selected"
                                  : ""
                              }
                            >
                              <span>{l("Center")}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedSettingsOne("alignment", "right");
                              }}
                              className={
                                alignment && alignment === "right"
                                  ? "selected"
                                  : ""
                              }
                            >
                              <span>{l("Right")}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.sliderTextSettings && (
                    <li
                      className={this.state.currentDrop === 33 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(33)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 33
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Title Style")}
                      </div>
                      {this.state.currentDrop === 33 && (
                        <div className="body">
                          {this._sliderTextOptions(sliderSettings, "title")}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.sliderTextSettings && (
                    <li
                      className={this.state.currentDrop === 34 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(34)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 34
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Subtitle Style")}
                      </div>
                      {this.state.currentDrop === 34 && (
                        <div className="body">
                          {this._sliderTextOptions(sliderSettings, "subtitle")}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.sliderLinkSettings && (
                    <li
                      className={this.state.currentDrop === 77 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(77)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 77
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Link Style")}
                      </div>
                      {this.state.currentDrop === 77 && (
                        <div className="body">
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">
                                {l("Background Color")}
                              </label>
                              <ColorSetter
                                color={
                                  (sliderSettings &&
                                    sliderSettings.linkBgColor) ||
                                  ""
                                }
                                onChangeComplete={(color) => {
                                  this._changedSliderStyle(
                                    "linkBgColor",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </div>
                          {this._sliderTextOptions(sliderSettings, "link")}
                          {this._cornersOptions(
                            (sliderSettings &&
                              sliderSettings.link_borderRadius) ||
                            {},
                            "link_borderRadius",
                            this._changedSliderStyleTwo
                          )}

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Icon")}</label>
                              <button
                                className={`dark gk-button gk-default gk-small gk-${sliderSettings && sliderSettings.useIcon
                                    ? "primary"
                                    : "secondary"
                                  }`}
                                onClick={() => {
                                  this._changedSliderStyle(
                                    "useIcon",
                                    sliderSettings && sliderSettings.useIcon
                                      ? !sliderSettings.useIcon
                                      : true
                                  );
                                }}
                              >
                                <span>{l("Button has icon")}</span>
                              </button>
                            </div>
                          </div>

                          {sliderSettings && sliderSettings.useIcon && (
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">
                                  {l("Icon position")}
                                </label>

                                <Select
                                  value={
                                    (sliderSettings &&
                                      sliderSettings.iconPosition) ||
                                    "left"
                                  }
                                  onChange={(value) => {
                                    this._changedSliderStyle(
                                      "iconPosition",
                                      value
                                    );
                                  }}
                                  options={[
                                    { label: l("Left"), value: "left" },
                                    { label: l("Right"), value: "right" },
                                  ]}
                                  dark
                                />
                              </div>
                            </div>
                          )}
                          {sliderSettings && sliderSettings.useIcon && (
                            <div className="section">
                              <label className="small">{l("Icons list")}</label>
                              <TextField
                                placeholder={l("Search Icon")}
                                value={this.state.searchIcon || ""}
                                onChange={(value) => {
                                  this.setState({ searchIcon: value });
                                }}
                                dark
                              />
                              <div className="fa-icon-container">
                                {iconsList.map(
                                  (icon, index) =>
                                    icon[1].match(
                                      new RegExp(this.state.searchIcon, "i")
                                    ) && (
                                      <span
                                        className={
                                          (sliderSettings &&
                                            sliderSettings.iconClass === icon &&
                                            "active") ||
                                          ""
                                        }
                                        key={index}
                                        onClick={() => {
                                          this._changedSliderStyle(
                                            "iconClass",
                                            icon
                                          );
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={[icon[0], icon[1]]}
                                        />
                                      </span>
                                    )
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.sliderTestimonialSettings && (
                    <li
                      className={this.state.currentDrop === 35 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(35)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 35
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Testimonial Styles")}
                      </div>
                      {this.state.currentDrop === 35 && (
                        <div className="body">
                          {this._sliderTextOptions(
                            sliderSettings,
                            "testimonial"
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.newsletterFieldBackgroundSettings && (
                    <li
                      className={this.state.currentDrop === 42 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(42)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 42
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Text field background")}
                      </div>
                      {this.state.currentDrop === 42 && (
                        <div className="body">
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">
                                {l("Background color")}
                              </label>
                              <ColorSetter
                                color={
                                  (newsletterSettings &&
                                    newsletterSettings.flBackground) ||
                                  ""
                                }
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "flBackground",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.newsletterFieldTextSettings && (
                    <li
                      className={this.state.currentDrop === 43 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(43)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 43
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Text field font settings")}
                      </div>
                      {this.state.currentDrop === 43 && (
                        <div className="body">
                          <div className="section">
                            <Select
                              value={
                                (newsletterSettings &&
                                  newsletterSettings.flFontFamilyId) ||
                                ""
                              }
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "newsletterSettings",
                                  "flFontFamilyId",
                                  value,
                                  () => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "flFontFamily",
                                      this.fontList[value].cssName
                                    );
                                  }
                                );
                              }}
                              placeholder={l("Google font")}
                              options={this._fontsFamilyOptions()}
                              dark
                            />
                          </div>

                          <div className="section">
                            <label className="small">{l("Size")}</label>
                            <SliderRange
                              value={
                                (newsletterSettings &&
                                  newsletterSettings.flFontSize) ||
                                16
                              }
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "newsletterSettings",
                                  "flFontSize",
                                  value
                                );
                              }}
                            />
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <Select
                                value={
                                  (newsletterSettings &&
                                    newsletterSettings.flFontWeight) ||
                                  ""
                                }
                                onChange={(value) => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "flFontWeight",
                                    value
                                  );
                                }}
                                placeholder={l("Font weight")}
                                options={this._fontsWeightOptions(
                                  (newsletterSettings &&
                                    newsletterSettings.flFontFamilyId) ||
                                  "",
                                  (newsletterSettings &&
                                    newsletterSettings.flFontFamily) ||
                                  ""
                                )}
                                dark
                              />

                              <ColorSetter
                                color={newsletterSettings.flColor || ""}
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "flColor",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </div>

                          <div className="section">
                            <ul className="inline-options dark grow">
                              <li
                                className={
                                  newsletterSettings &&
                                    newsletterSettings.flTextAlign === "left"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "flTextAlign",
                                    "left"
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={["fa", "align-left"]} />
                              </li>
                              <li
                                className={
                                  newsletterSettings &&
                                    newsletterSettings.flTextAlign === "center"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "flTextAlign",
                                    "center"
                                  );
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={["fa", "align-center"]}
                                />
                              </li>
                              <li
                                className={
                                  newsletterSettings &&
                                    newsletterSettings.flTextAlign === "right"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "flTextAlign",
                                    "right"
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={["fa", "align-right"]} />
                              </li>
                              <li
                                className={
                                  newsletterSettings &&
                                    newsletterSettings.flTextAlign === "justify"
                                    ? "selected"
                                    : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "flTextAlign",
                                    "justify"
                                  );
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={["fa", "align-justify"]}
                                />
                              </li>
                            </ul>
                          </div>

                          <div className="section">
                            <Select
                              value={
                                newsletterSettings &&
                                newsletterSettings.flLetterSpacing
                              }
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "newsletterSettings",
                                  "flLetterSpacing",
                                  value
                                );
                              }}
                              placeholder={l("Letter spacing")}
                              options={[
                                {
                                  label: l("Tight"),
                                  value: -1,
                                },
                                {
                                  label: l("Normal"),
                                  value: "0",
                                },
                                {
                                  label: l("Wide"),
                                  value: 1,
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.newsletterFieldBorderSettings && (
                    <li
                      className={this.state.currentDrop === 44 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(44)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 44
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Text field border")}
                      </div>
                      {this.state.currentDrop === 44 && (
                        <div className="body">
                          {this._cornersOptions(
                            (newsletterSettings &&
                              newsletterSettings.flBorderRadius) ||
                            {},
                            "flBorderRadius",
                            (item, target, value) => {
                              let objectValue = {
                                ...this.state.datas.newsletterSettings[item],
                                ...this.state.settings.newsletterSettings[item],
                                [target]: value,
                              };

                              this._changedSettingsTwo(
                                "newsletterSettings",
                                item,
                                objectValue
                              );
                            }
                          )}

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.flBorderStyle === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "flBorderStyle",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.flBorderStyle === "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "flBorderStyle",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.flBorderStyle ===
                                      "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "flBorderStyle",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.flBorderStyle ===
                                      "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "flBorderStyle",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.flBorderTarget ===
                                        "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "flBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.flBorderTarget ===
                                          "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.flBorderTarget ===
                                        "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "flBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.flBorderTarget ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.flBorderTarget ===
                                        "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "flBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.flBorderTarget ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.flBorderTarget ===
                                        "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "flBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.flBorderTarget ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.flBorderTarget ===
                                        "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "flBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.flBorderTarget ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                                {newsletterSettings.flBorderTarget && (
                                  <Select
                                    value={
                                      newsletterSettings.flBorderWidth || 0
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "flBorderWidth",
                                        parseInt(value)
                                      );
                                    }}
                                    placeholder={l("Width")}
                                    options={[
                                      { label: "0", value: 0 },
                                      { label: "1", value: 1 },
                                      { label: "2", value: 2 },
                                      { label: "3", value: 3 },
                                      { label: "4", value: 4 },
                                      { label: "5", value: 5 },
                                      { label: "6", value: 6 },
                                      { label: "7", value: 7 },
                                      { label: "8", value: 8 },
                                      { label: "9", value: 9 },
                                    ]}
                                    dark
                                  />
                                )}
                              </div>
                            </div>
                            {newsletterSettings.flBorderTarget && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Border color")}
                                  </label>
                                  <ColorSetter
                                    label={l("Border color")}
                                    color={
                                      newsletterSettings.flBorderColor ||
                                      "#000000"
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "flBorderColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.newsletterButtonBackgroundSettings && (
                    <li
                      className={this.state.currentDrop === 46 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(46)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 46
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Button background")}
                      </div>
                      {this.state.currentDrop === 46 && (
                        <div className="body">
                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">
                                {l("Background color")}
                              </label>
                              <ColorSetter
                                color={
                                  (newsletterSettings &&
                                    newsletterSettings.btnBackground) ||
                                  ""
                                }
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "btnBackground",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.newsletterButtonTextSettings && (
                    <li
                      className={this.state.currentDrop === 47 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(47)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 47
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Button font settings")}
                      </div>
                      {this.state.currentDrop === 47 && (
                        <div className="body">
                          <div className="section">
                            <Select
                              value={
                                (newsletterSettings &&
                                  newsletterSettings.btnFontFamilyId) ||
                                ""
                              }
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "newsletterSettings",
                                  "btnFontFamilyId",
                                  value,
                                  () => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "btnFontFamily",
                                      this.fontList[value].cssName
                                    );
                                  }
                                );
                              }}
                              placeholder={l("Google font")}
                              options={this._fontsFamilyOptions()}
                              dark
                            />
                          </div>

                          <div className="section">
                            <label className="small">{l("Size")}</label>
                            <SliderRange
                              value={
                                (newsletterSettings &&
                                  newsletterSettings.btnFontSize) ||
                                16
                              }
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "newsletterSettings",
                                  "btnFontSize",
                                  value
                                );
                              }}
                            />
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <Select
                                value={
                                  (newsletterSettings &&
                                    newsletterSettings.btnFontWeight) ||
                                  ""
                                }
                                onChange={(value) => {
                                  this._changedDatasTwo(
                                    "newsletterSettings",
                                    "btnFontWeight",
                                    value
                                  );
                                }}
                                placeholder={l("Font weight")}
                                options={this._fontsWeightOptions(
                                  (newsletterSettings &&
                                    newsletterSettings.btnFontFamilyId) ||
                                  "",
                                  (newsletterSettings &&
                                    newsletterSettings.btnFontFamily) ||
                                  ""
                                )}
                                dark
                              />

                              <ColorSetter
                                color={newsletterSettings.btnColor || ""}
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "newsletterSettings",
                                    "btnColor",
                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </div>

                          <div className="section">
                            <Select
                              value={
                                newsletterSettings &&
                                newsletterSettings.btnLetterSpacing
                              }
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "newsletterSettings",
                                  "btnLetterSpacing",
                                  value
                                );
                              }}
                              placeholder={l("Letter spacing")}
                              options={[
                                {
                                  label: l("Tight"),
                                  value: -1,
                                },
                                {
                                  label: l("Normal"),
                                  value: "0",
                                },
                                {
                                  label: l("Wide"),
                                  value: 1,
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.newsletterButtonBorderSettings && (
                    <li
                      className={this.state.currentDrop === 49 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(49)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 49
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("Button border")}
                      </div>
                      {this.state.currentDrop === 49 && (
                        <div className="body">
                          {this._cornersOptions(
                            (newsletterSettings &&
                              newsletterSettings.btnBorderRadius) ||
                            {},
                            "btnBorderRadius",
                            (item, target, value) => {
                              let objectValue = {
                                ...this.state.datas.newsletterSettings[item],
                                ...this.state.settings.newsletterSettings[item],
                                [target]: value,
                              };

                              this._changedSettingsTwo(
                                "newsletterSettings",
                                item,
                                objectValue
                              );
                            }
                          )}

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Style")}</label>
                              <ul className="inline-options dark">
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.btnBorderStyle === null
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "btnBorderStyle",
                                      null
                                    );
                                  }}
                                >
                                  <Icon icon="time" />
                                </li>
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.btnBorderStyle ===
                                      "solid"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "btnBorderStyle",
                                      "solid"
                                    );
                                  }}
                                >
                                  <Icon icon="solid" />
                                </li>
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.btnBorderStyle ===
                                      "dotted"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "btnBorderStyle",
                                      "dotted"
                                    );
                                  }}
                                >
                                  <Icon icon="dotted" />
                                </li>
                                <li
                                  className={
                                    newsletterSettings &&
                                      newsletterSettings.btnBorderStyle ===
                                      "dashed"
                                      ? "selected"
                                      : ""
                                  }
                                  onClick={() => {
                                    this._changedSettingsTwo(
                                      "newsletterSettings",
                                      "btnBorderStyle",
                                      "dashed"
                                    );
                                  }}
                                >
                                  <Icon icon="dashed2" />
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="section">
                            <div className="gk-form-row-container">
                              <label className="small">{l("Width")}</label>
                              <div>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.btnBorderTarget ===
                                        "border"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "btnBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.btnBorderTarget ===
                                          "border"
                                          ? null
                                          : "border"
                                      );
                                    }}
                                  >
                                    <Icon icon="border" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.btnBorderTarget ===
                                        "borderTop"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "btnBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.btnBorderTarget ===
                                          "borderTop"
                                          ? null
                                          : "borderTop"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderTop" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.btnBorderTarget ===
                                        "borderBottom"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "btnBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.btnBorderTarget ===
                                          "borderBottom"
                                          ? null
                                          : "borderBottom"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderBottom" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.btnBorderTarget ===
                                        "borderRight"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "btnBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.btnBorderTarget ===
                                          "borderRight"
                                          ? null
                                          : "borderRight"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderRight" />{" "}
                                  </li>
                                  <li
                                    className={
                                      newsletterSettings &&
                                        newsletterSettings.btnBorderTarget ===
                                        "borderLeft"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "btnBorderTarget",
                                        newsletterSettings &&
                                          newsletterSettings.btnBorderTarget ===
                                          "borderLeft"
                                          ? null
                                          : "borderLeft"
                                      );
                                    }}
                                  >
                                    <Icon icon="borderLeft" />{" "}
                                  </li>
                                </ul>
                                {newsletterSettings.btnBorderTarget && (
                                  <Select
                                    value={
                                      newsletterSettings.btnBorderWidth || 0
                                    }
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "btnBorderWidth",
                                        parseInt(value)
                                      );
                                    }}
                                    placeholder={l("Width")}
                                    options={[
                                      { label: "0", value: 0 },
                                      { label: "1", value: 1 },
                                      { label: "2", value: 2 },
                                      { label: "3", value: 3 },
                                      { label: "4", value: 4 },
                                      { label: "5", value: 5 },
                                      { label: "6", value: 6 },
                                      { label: "7", value: 7 },
                                      { label: "8", value: 8 },
                                      { label: "9", value: 9 },
                                    ]}
                                    dark
                                  />
                                )}
                              </div>
                            </div>
                            {newsletterSettings.btnBorderTarget && (
                              <div className="section">
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Border color")}
                                  </label>
                                  <ColorSetter
                                    label={l("Border color")}
                                    color={
                                      newsletterSettings.btnBorderColor ||
                                      "#000000"
                                    }
                                    onChangeComplete={(color) => {
                                      this._changedSettingsTwo(
                                        "newsletterSettings",
                                        "btnBorderColor",
                                        color
                                      );
                                    }}
                                    right
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.newsletterFieldTextSettings && (
                    <li
                      className={this.state.currentDrop === 101 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(101)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 101
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("View styles")}
                      </div>
                      {this.state.currentDrop === 101 && (
                        <div className="body">
                          <div className="section">
                            <label className="small">{l("Spacing")}</label>
                            <SliderRange
                              value={
                                (viewSettings &&
                                  viewSettings.marginInBetween) ||
                                10
                              }
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "viewSettings",
                                  "marginInBetween",
                                  value
                                );
                              }}
                            />
                          </div>

                          <div className="section">
                            <ul className="inline-options dark grow">
                              <li
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "viewSettings",
                                    "showInline",
                                    true
                                  );
                                }}
                                className={
                                  viewSettings.showInline ? "selected" : ""
                                }
                              >
                                <span>{l("inline")}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "viewSettings",
                                    "showInline",
                                    false
                                  );
                                }}
                                className={
                                  !viewSettings.showInline ? "selected" : ""
                                }
                              >
                                <span>{l("Not inline")}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                    </li>
                  )}

                  {/* 
                  {availableSettings.newsletterButtonBorderSettings && (
                    <li
                      className={this.state.currentDrop === 50 ? "active" : ""}
                    >
                      <div className="head" onClick={() => this._dropDown(50)}>
                        <Icon
                          icon={
                            this.state.currentDrop === 50
                              ? "dropup"
                              : "dropdown"
                          }
                        />
                        {l("View settings")}
                      </div>
                      {this.state.currentDrop === 50 && (
                        <li className="body">
                          <div className="section">
                            <ul className="inline-options dark grow">
                              <li
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "viewSettings",
                                    "showInline",
                                    true
                                  );
                                }}
                                className={
                                  viewSettings?.showInline ? "selected" : ""
                                }
                              >
                                <span>{l("Inlined")}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "viewSettings",
                                    "showInline",
                                    false
                                  );
                                }}
                                className={
                                  !viewSettings?.showInline ? "selected" : ""
                                }
                              >
                                <span>{l("Not inlined")}</span>
                              </li>
                            </ul>
                          </div>
                        </li>
                      )}
                    </li>
                  )} */}

                  {availableSettings?.priceStyle && (
                    <li>
                      <div className="head">
                        {availableSettings?.text?.title || l("Price Style")}
                      </div>
                      <div className="body">
                        <div className="section">
                          <label className="small">{l("Size")}</label>
                          <SliderRange
                            value={priceSize || 16}
                            min={10}
                            max={100}
                            onChange={(value) => {
                              this._changedSettingsTwo(
                                "priceStyles",
                                "priceSize",
                                value
                              );
                            }}
                          />
                        </div>

                        <div className="section">
                          <>
                            <div className="gk-form-row-container">
                              <label className="small">Old Price Color</label>
                              <ColorSetter
                                color={opc || null}
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "priceStyles",
                                    "oldPriceColor",

                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </>
                          <br></br>
                          <>
                            <div className="gk-form-row-container">
                              <label className="small">New Price Color</label>
                              <ColorSetter
                                color={pc || null}
                                onChangeComplete={(color) => {
                                  this._changedSettingsTwo(
                                    "priceStyles",
                                    "priceColor",

                                    color
                                  );
                                }}
                                right
                              />
                            </div>
                          </>
                        </div>

                        <div className="section">
                          <ul className="inline-options dark grow">
                            <li
                              className={
                                pricePosition === "left" ? "selected" : ""
                              }
                              onClick={() => {
                                this._changedSettingsTwo(
                                  "priceStyles",
                                  "pricePosition",

                                  "left"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={["fa", "align-left"]} />
                            </li>
                            <li
                              className={
                                pricePosition === "center" ? "selected" : ""
                              }
                              onClick={() => {
                                this._changedSettingsTwo(
                                  "priceStyles",
                                  "pricePosition",

                                  "center"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={["fa", "align-center"]} />
                            </li>
                            <li
                              className={
                                pricePosition === "right" ? "selected" : ""
                              }
                              onClick={() => {
                                this._changedSettingsTwo(
                                  "priceStyles",
                                  "pricePosition",

                                  "right"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={["fa", "align-right"]} />
                            </li>
                            <li
                              className={
                                pricePosition === "justify" ? "selected" : ""
                              }
                              onClick={() => {
                                this._changedSettingsTwo(
                                  "priceStyles",
                                  "pricePosition",

                                  "justify"
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={["fa", "align-justify"]} />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.previousStepSettings && (
                    <li>
                      <div className="head">{l("Previous step styles")}</div>
                      <div className="body">
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">
                              {l("Background color")}
                            </label>
                            <ColorSetter
                              color={previousStepBackgroundColor || ""}
                              onChangeComplete={(color) => {
                                this._changedSettingsOne(
                                  "previousStepBackgroundColor",
                                  color
                                );
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">{l("Text color")}</label>
                            <ColorSetter
                              color={previousStepTextColor || ""}
                              onChangeComplete={(color) => {
                                this._changedSettingsOne(
                                  "previousStepTextColor",
                                  color
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.currentStepSettings && (
                    <li>
                      <div className="head">{l("Current step styles")}</div>
                      <div className="body">
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">
                              {l("Background color")}
                            </label>
                            <ColorSetter
                              color={currentStepBackgroundColor || ""}
                              onChangeComplete={(color) => {
                                this._changedSettingsOne(
                                  "currentStepBackgroundColor",
                                  color
                                );
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">{l("Text color")}</label>
                            <ColorSetter
                              color={currentStepTextColor || ""}
                              onChangeComplete={(color) => {
                                this._changedSettingsOne(
                                  "currentStepTextColor",
                                  color
                                );
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.nextStepSettings && (
                    <li
                      className="active"
                    >
                      <div className="head" >

                        {l("Next step color")}
                      </div>

                      <div className="body">
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">
                              {l("Background color")}
                            </label>
                            <ColorSetter
                              color={nextStepBackgroundColor || ""}
                              onChangeComplete={(color) => {
                                this._changedSettingsOne(
                                  "nextStepBackgroundColor",
                                  color
                                );
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">{l("Text color")}</label>
                            <ColorSetter
                              color={nextStepTextColor || ""}
                              onChangeComplete={(color) => {
                                this._changedSettingsOne(
                                  "nextStepTextColor",
                                  color
                                );
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>

                    </li>
                  )}

                  {availableSettings.dividerSettings && (
                    <li>
                      <div className="head">{l("Divider Styles")}</div>
                      <div className="body">
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">{l("Line Width")}</label>
                            <Select
                              dark
                              value={
                                (dividerLineWidth &&
                                  dividerLineWidth.toString()) ||
                                "0"
                              }
                              onChange={(value) => {
                                this._changedSettingsTwo(
                                  "divider",
                                  "dividerLineWidth",
                                  value
                                );
                              }}
                              options={[
                                {
                                  value: 0,
                                  label: l("0"),
                                },
                                {
                                  value: 1,
                                  label: l("1"),
                                },
                                {
                                  value: 2,
                                  label: l("2"),
                                },
                                {
                                  value: 3,
                                  label: l("3"),
                                },
                                {
                                  value: 4,
                                  label: l("4"),
                                },
                                {
                                  value: 5,
                                  label: l("5"),
                                },
                                {
                                  value: 6,
                                  label: l("6"),
                                },
                                {
                                  value: 7,
                                  label: l("7"),
                                },
                                {
                                  value: 8,
                                  label: l("8"),
                                },
                                {
                                  value: 9,
                                  label: l("9"),
                                },
                              ]}
                            />
                          </div>
                        </div>
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">{l("Line color")}</label>
                            <ColorSetter
                              color={dividerLineColor || "#000000"}
                              onChangeComplete={(color) => {
                                this._changedSettingsTwo(
                                  "divider",
                                  "dividerLineColor",
                                  color
                                );
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className="section">
                          <div className="gk-form-row-container">
                            <label className="small">{l("type")}</label>
                            <ul className="inline-options dark">
                              <li
                                className={
                                  dividerLineType === null ? "selected" : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "divider",
                                    "dividerLineType",
                                    null
                                  );
                                }}
                              >
                                <Icon icon="time" />
                              </li>
                              <li
                                className={
                                  dividerLineType === "solid" ? "selected" : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "divider",
                                    "dividerLineType",
                                    "solid"
                                  );
                                }}
                              >
                                <Icon icon="solid" />
                              </li>
                              <li
                                className={
                                  dividerLineType === "dotted" ? "selected" : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "divider",
                                    "dividerLineType",
                                    "dotted"
                                  );
                                }}
                              >
                                <Icon icon="dotted" />
                              </li>
                              <li
                                className={
                                  dividerLineType === "dashed" ? "selected" : ""
                                }
                                onClick={() => {
                                  this._changedSettingsTwo(
                                    "divider",
                                    "dividerLineType",
                                    "dashed"
                                  );
                                }}
                              >
                                <Icon icon="dashed2" />
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="section">
                          <label className="small">{l("Spacing Top")}</label>
                          <SliderRange
                            value={dividerSpacingTop || 10}
                            min={10}
                            max={100}
                            onChange={(value) => {
                              this._changedSettingsTwo(
                                "divider",
                                "dividerSpacingTop",
                                value
                              );
                            }}
                          />
                        </div>
                        <div className="section">
                          <label className="small">{l("Spacing Bottom")}</label>
                          <SliderRange
                            value={dividerSpacingBottom || 10}
                            min={10}
                            max={100}
                            onChange={(value) => {
                              this._changedSettingsTwo(
                                "divider",
                                "dividerSpacingBottom",
                                value
                              );
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  )}

                  {!this.state.hideAdvanceSettings && (
                    <li className={this.state.advanceSettings ? "active" : ""}>
                      <div
                        className="head"
                        onClick={() => {
                          this.setState({
                            advanceSettings: !this.state.advanceSettings,
                          });
                        }}
                      >
                        <Icon
                          icon={
                            this.state.advanceSettings ? "dropup" : "dropdown"
                          }
                        />
                        {l("Advanced Styling")}
                      </div>
                    </li>
                  )}

                  {this.state.advanceSettings && (
                    <>
                      {availableSettings?.text?.fontFamily && (
                        <li>
                          <div className="head">{l("Font Family")}</div>
                          <div className="body">
                            <div className="section">
                              <Select
                                value={
                                  (textSettings &&
                                    textSettings?.fontFamilyId) ||
                                  ""
                                }
                                onChange={(value) => {
                                  this._changedSettingsTwo(
                                    "text",
                                    "fontFamilyId",
                                    value,
                                    () => {
                                      this._changedSettingsTwo(
                                        "text",
                                        "fontFamily",
                                        this.fontList[value].cssName
                                      );
                                    }
                                  );
                                }}
                                placeholder={l("Google font")}
                                options={this._fontsFamilyOptions()}
                                dark
                              />
                            </div>
                          </div>
                        </li>
                      )}
                      {availableSettings.background && (
                        <li>
                          <div className="head">{l("Background")}</div>
                          <div className="body">
                            <div className="section">
                              {!(
                                backgroundSettings &&
                                backgroundSettings.backgroundImage
                              ) && (
                                  <div className="gk-form-row-container">
                                    <label className="small">
                                      {l("Background color")}
                                    </label>
                                    <NewColorPicker
                                      color={
                                        (backgroundSettings &&
                                          backgroundSettings.backgroundColor) ||
                                        ""
                                      }
                                      onChangeComplete={(color) => {
                                        this._changedSettingsTwo(
                                          "background",
                                          "backgroundColor",
                                          color
                                        );
                                      }}
                                      right
                                    />
                                  </div>
                                )}
                              <ImageUploader
                                title={l("Image")}
                                withIcon={true}
                                buttonText={l("Upload image")}
                                onChange={(url) => {
                                  this._changedSettingsTwo(
                                    "background",
                                    "backgroundImage",
                                    url
                                  );
                                }}
                                imgExtension={[
                                  ".jpg",
                                  ".gif",
                                  ".png",
                                  ".gif",
                                  ".jpeg",
                                  ".webp",
                                ]}
                                maxFileSize={5242880}
                                withPreview={true}
                                defaultImages={
                                  backgroundSettings &&
                                    backgroundSettings.backgroundImage !==
                                    undefined &&
                                    backgroundSettings.backgroundImage !== null
                                    ? backgroundSettings.backgroundImage
                                    : ""
                                }
                              />
                            </div>
                            {backgroundSettings &&
                              backgroundSettings.backgroundImage && (
                                <div className="section">
                                  <div className="gk-form-row-container">
                                    <label className="small">
                                      {l("Repeat")}
                                    </label>
                                    <Select
                                      value={
                                        backgroundSettings.backgroundRepeat ||
                                        "repeat"
                                      }
                                      onChange={(value) => {
                                        this._changedSettingsTwo(
                                          "background",
                                          "backgroundRepeat",
                                          value
                                        );
                                      }}
                                      options={[
                                        {
                                          label: l("Repeat"),
                                          value: "repeat",
                                        },
                                        {
                                          label: l("Repeat X"),
                                          value: "repeat-x",
                                        },
                                        {
                                          label: l("Repeat T"),
                                          value: "repeat-y",
                                        },
                                        {
                                          label: l("No repeat"),
                                          value: "no-repeat",
                                        },
                                      ]}
                                      dark
                                    />
                                  </div>
                                </div>
                              )}
                            {backgroundSettings &&
                              backgroundSettings.backgroundImage && (
                                <div className="section">
                                  <div className="gk-form-row-container">
                                    <label className="small">{l("Size")}</label>
                                    <ul className="inline-options dark">
                                      <li
                                        className={
                                          backgroundSettings.backgroundSize ===
                                            "initial"
                                            ? "selected"
                                            : ""
                                        }
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "background",
                                            "backgroundSize",
                                            "initial"
                                          );
                                        }}
                                      >
                                        <span>{l("Auto")}</span>
                                      </li>
                                      <li
                                        className={
                                          backgroundSettings.backgroundSize ===
                                            "cover"
                                            ? "selected"
                                            : ""
                                        }
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "background",
                                            "backgroundSize",
                                            "cover"
                                          );
                                        }}
                                      >
                                        <span>{l("Cover")}</span>
                                      </li>
                                      <li
                                        className={
                                          backgroundSettings.backgroundSize ===
                                            "contain"
                                            ? "selected"
                                            : ""
                                        }
                                        onClick={() => {
                                          this._changedSettingsTwo(
                                            "background",
                                            "backgroundSize",
                                            "contain"
                                          );
                                        }}
                                      >
                                        <span>{l("Contain")}</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            {backgroundSettings &&
                              backgroundSettings.backgroundImage && (
                                <div className="section">
                                  <div className="gk-form-row-container">
                                    <label className="small">
                                      {l("Align")}
                                    </label>
                                    <div className="gk-bg-align-box">
                                      <div>
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "left top"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-top-left"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "left top"
                                            );
                                          }}
                                        />
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "center top"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-top-center"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "center top"
                                            );
                                          }}
                                        />
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "right top"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-top-right"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "right top"
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "left center"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-middle-left"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "left center"
                                            );
                                          }}
                                        />
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "center center" ||
                                              !backgroundSettings.backgroundPosition
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-middle-center"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "center center"
                                            );
                                          }}
                                        />
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "right center"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-middle-right"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "right center"
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "left bottom"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-bottom-left"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "left bottom"
                                            );
                                          }}
                                        />
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "center bottom"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-bottom-center"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "center bottom"
                                            );
                                          }}
                                        />
                                        <Icon
                                          className={
                                            backgroundSettings.backgroundPosition ==
                                              "right bottom"
                                              ? "active"
                                              : ""
                                          }
                                          icon="align-bottom-right"
                                          onClick={() => {
                                            this._changedSettingsTwo(
                                              "background",
                                              "backgroundPosition",
                                              "right bottom"
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            {backgroundSettings &&
                              backgroundSettings.backgroundImage && (
                                <div className="section">
                                  <div className="gk-form-row-container">
                                    <label className="small">
                                      {l("Background overlay color")}
                                    </label>
                                    <ColorSetter
                                      color={
                                        (backgroundSettings &&
                                          backgroundSettings.backgroundColor) ||
                                        ""
                                      }
                                      onChangeComplete={(color) => {
                                        this._changedSettingsTwo(
                                          "background",
                                          "backgroundColor",
                                          color
                                        );
                                      }}
                                      right
                                    />
                                  </div>
                                </div>
                              )}
                            {backgroundSettings &&
                              backgroundSettings.backgroundImage && (
                                <div className="section">
                                  <label className="small">
                                    {l("Background overlay opacity")} :
                                  </label>
                                  <SliderRange
                                    value={
                                      (backgroundSettings &&
                                        backgroundSettings.overlayOpacity) ||
                                      0
                                    }
                                    min={0}
                                    max={100}
                                    onChange={(value) => {
                                      this._changedSettingsTwo(
                                        "background",
                                        "overlayOpacity",
                                        value
                                      );
                                    }}
                                  />
                                </div>
                              )}
                            {backgroundSettings &&
                              backgroundSettings.backgroundImage && (
                                <div className="section">
                                  <div className="gk-form-row-container">
                                    <label className="small">
                                      {l("Parallax background")}
                                    </label>
                                    <Switch
                                      checked={
                                        backgroundSettings &&
                                        backgroundSettings.parallax
                                      }
                                      onChange={(e) => {
                                        this._changedSettingsTwo(
                                          "background",
                                          "parallax",
                                          e.target.checked
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                          </div>
                        </li>
                      )}

                      {availableSettings.border && (
                        <li>
                          <div className="head">{l("Border")}</div>
                          <div className="body">
                            {this._cornersOptions(
                              borderRadius,
                              "borderRadius",
                              this._changedSettingsTwo
                            )}

                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Style")}</label>
                                <ul className="inline-options dark">
                                  <li
                                    className={
                                      border && border.border_style === null
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "border",
                                        "border_style",
                                        null
                                      );
                                    }}
                                  >
                                    <Icon icon="time" />
                                  </li>
                                  <li
                                    className={
                                      border && border.border_style === "solid"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "border",
                                        "border_style",
                                        "solid"
                                      );
                                    }}
                                  >
                                    <Icon icon="solid" />
                                  </li>
                                  <li
                                    className={
                                      border && border.border_style === "dotted"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "border",
                                        "border_style",
                                        "dotted"
                                      );
                                    }}
                                  >
                                    <Icon icon="dotted" />
                                  </li>
                                  <li
                                    className={
                                      border && border.border_style === "dashed"
                                        ? "selected"
                                        : ""
                                    }
                                    onClick={() => {
                                      this._changedSettingsTwo(
                                        "border",
                                        "border_style",
                                        "dashed"
                                      );
                                    }}
                                  >
                                    <Icon icon="dashed2" />
                                  </li>
                                </ul>
                              </div>
                            </div>

                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Target")}</label>
                                <div>
                                  <ul className="inline-options dark">
                                    <li
                                      className={
                                        border &&
                                          border.border_target === "border"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "border",
                                          "border_target",
                                          border &&
                                            border.border_target === "border"
                                            ? null
                                            : "border"
                                        );
                                      }}
                                    >
                                      <Icon icon="border" />{" "}
                                    </li>
                                    <li
                                      className={
                                        border &&
                                          border.border_target === "borderTop"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "border",
                                          "border_target",
                                          border &&
                                            border.border_target === "borderTop"
                                            ? null
                                            : "borderTop"
                                        );
                                      }}
                                    >
                                      <Icon icon="borderTop" />{" "}
                                    </li>
                                    <li
                                      className={
                                        border &&
                                          border.border_target === "borderBottom"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "border",
                                          "border_target",
                                          border &&
                                            border.border_target ===
                                            "borderBottom"
                                            ? null
                                            : "borderBottom"
                                        );
                                      }}
                                    >
                                      <Icon icon="borderBottom" />{" "}
                                    </li>
                                    <li
                                      className={
                                        border &&
                                          border.border_target === "borderRight"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "border",
                                          "border_target",
                                          border &&
                                            border.border_target ===
                                            "borderRight"
                                            ? null
                                            : "borderRight"
                                        );
                                      }}
                                    >
                                      <Icon icon="borderRight" />{" "}
                                    </li>
                                    <li
                                      className={
                                        border &&
                                          border.border_target === "borderLeft"
                                          ? "selected"
                                          : ""
                                      }
                                      onClick={() => {
                                        this._changedSettingsTwo(
                                          "border",
                                          "border_target",
                                          border &&
                                            border.border_target ===
                                            "borderLeft"
                                            ? null
                                            : "borderLeft"
                                        );
                                      }}
                                    >
                                      <Icon icon="borderLeft" />{" "}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="section">
                              <div className="gk-form-row-container">
                                <label className="small">{l("Width")}</label>
                                <div>
                                  {border && border.border_target && (
                                    <Select
                                      value={
                                        (border && border.border_width) || 0
                                      }
                                      onChange={(value) => {
                                        this._changedSettingsTwo(
                                          "border",
                                          "border_width",
                                          parseInt(value)
                                        );
                                      }}
                                      placeholder={l("Width")}
                                      options={[
                                        { label: "0", value: 0 },
                                        { label: "1", value: 1 },
                                        { label: "2", value: 2 },
                                        { label: "3", value: 3 },
                                        { label: "4", value: 4 },
                                        { label: "5", value: 5 },
                                        { label: "6", value: 6 },
                                        { label: "7", value: 7 },
                                        { label: "8", value: 8 },
                                        { label: "9", value: 9 },
                                      ]}
                                      dark
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="section">
                              {border && border.border_target && (
                                <div className="gk-form-row-container">
                                  <label className="small">
                                    {l("Border color")}
                                  </label>
                                  <div>
                                    <ColorSetter
                                      label={l("Border color")}
                                      color={
                                        (border && border.border_color) ||
                                        "#000000"
                                      }
                                      onChangeComplete={(color) => {
                                        this._changedSettingsTwo(
                                          "border",
                                          "border_color",
                                          color
                                        );
                                      }}
                                      right
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </li>
                      )}

                      {availableSettings.spacing && (
                        <li>
                          <div className="head">{l("Block Spacing")}</div>
                          <div className="body">
                            <HoverSpacer
                              spacingSettings={spacingSettings}
                              onChange={this._changedSettingsTwo}
                            />
                          </div>
                        </li>
                      )}
                    </>
                  )}
                  <li className="d-flex align-items-center"></li>
                </ul>
              )}
            </div>
          </div>
        </div>
      );
    } else return false;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlockSettings);
